{
  "moduleHome": {
    "screensIn": "Screens in {{module}}",
    "related": "Related screens",
    "quickActions": "Quick actions",
    "needsAttention": "Needs attention",
    "moreActions": "More"
  },
  "catalogPicker": {
    "placeholder": "Choose an item",
    "search": "Search by name, SKU, part number or barcode…",
    "empty": "No items match this search",
    "searching": "Searching…",
    "loadMore": "Load more",
    "loadingMore": "Loading…",
    "loadError": "The item list could not be loaded.",
    "partNumber": "Part no. {{value}}",
    "clear": "Clear item",
    "stock": {
      "inStock": "In stock in this warehouse",
      "outOfStock": "Out of stock in this warehouse",
      "notHere": "Not in this warehouse",
      "available": "{{quantity}} available",
      "chooseWarehouse": "Choose a warehouse first"
    }
  },
  "app": {
    "admin": "Multaqa ERP Admin",
    "company": "Multaqa ERP"
  },
  "sealedByCompany": "Sealed by {{name}}",
  "approval": {
    "pendingTitle": "Awaiting approval",
    "pendingDescription": "This document is submitted and cannot post until it is approved.",
    "rejectedTitle": "Approval rejected",
    "stepOf": "Step {{step}} of {{count}}",
    "approve": "Approve",
    "reject": "Reject",
    "comment": "Comment",
    "submit": "Save decision",
    "cancel": "Cancel",
    "priorDecisionsTitle": "Decisions so far",
    "approvedBy": "{{name}} approved",
    "rejectedBy": "{{name}} rejected",
    "unknownDecider": "Someone",
    "decisionsTitle": "Approval decisions",
    "decisionsErrorTitle": "Approval decisions did not load",
    "decisionsErrorDescription": "Try again to see who decided this document."
  },
  "audit": {
    "title": "Platform audit",
    "subtitle": "The append-only trail of platform administration events.",
    "columns": {
      "occurredAt": "Occurred at",
      "action": "Action",
      "entity": "Entity",
      "actor": "Actor",
      "company": "Company",
      "group": "Group",
      "oldValues": "Old values",
      "newValues": "New values"
    },
    "actorType": {
      "user": "user",
      "platform_admin": "platform admin",
      "system": "system"
    },
    "noValue": "—",
    "emptyTitle": "No audit events yet",
    "emptyBody": "Administration events appear here once they are recorded.",
    "supportRequired": {
      "title": "A support session is required",
      "body": "A group’s audit trail is customer data. Open a support session into the group to read it."
    },
    "groupPicker": "Group"
  },
  "action": {
    "save": "Save",
    "more": "More",
    "view": "View",
    "cancel": "Cancel",
    "unlink": "Unlink",
    "delete": "Delete",
    "edit": "Edit",
    "create": "Create",
    "search": "Search",
    "signIn": "Sign in",
    "signOut": "Sign out",
    "back": "Back",
    "retry": "Try again",
    "goBack": "Go back",
    "reload": "Reload the page",
    "copy": "Copy",
    "copied": "Copied",
    "yes": "Yes",
    "no": "No",
    "actions": "Actions",
    "previousPage": "Previous page",
    "nextPage": "Next page",
    "total": "Total",
    "clearFilters": "Clear filters",
    "filter": "Filter",
    "filterActive": "Filter, {{count}} active",
    "moreFilters": "More filters",
    "fewerFilters": "Fewer filters",
    "moreFiltersActive": "More filters ({{count}} active)",
    "fewerFiltersActive": "Fewer filters ({{count}} active)",
    "close": "Close",
    "remove": "Remove",
    "clearAll": "Clear all",
    "download": "Download",
    "downloadPdf": "Download PDF",
    "downloadPdfFailed": "The document could not be downloaded."
  },
  "pagination": {
    "pageOf": "Page {{current}} of {{total}}",
    "range": "{{from}}–{{to}} of {{total}}",
    "rowsPerPage": "Rows per page"
  },
  "date": {
    "openCalendar": "Open calendar",
    "clear": "Clear date"
  },
  "accountPicker": {
    "balanceSheet": "BAL",
    "balanceSheetFullName": "Balance sheet",
    "profitAndLoss": "P&L",
    "profitAndLossFullName": "Profit and loss"
  },
  "shortcuts": {
    "title": "Keyboard shortcuts",
    "search": "Search and go anywhere",
    "switchCompany": "Switch company",
    "newLine": "Add a line to a document",
    "moveLines": "Move between a document’s lines",
    "sheet": "Show this list",
    "close": "Close a dialog or panel"
  },
  "nav": {
    "dashboard": "Dashboard",
    "customers": "Customers",
    "suppliers": "Suppliers",
    "products": "Products",
    "productCategories": "Product categories",
    "collections": "Collections",
    "productAttributes": "Product attributes",
    "unitsOfMeasure": "Units of measure",
    "tags": "Tags",
    "settings": "Settings",
    "toggleSidebar": "Toggle sidebar",
    "toggleTheme": "Toggle theme",
    "changeLanguage": "Change language",
    "notifications": "Notifications",
    "alerts": "Alerts",
    "payslips": "Payslips"
  },
  "scan": {
    "title": "Scan a code",
    "lookupHint": "Scan or type a product barcode, SKU, lot, bin or warehouse code.",
    "inputLabel": "Code",
    "submit": "Find",
    "failed": "The code could not be looked up. Try again.",
    "notFound": "Nothing matches “{{code}}”",
    "notFoundHint": "Check the label. It may also belong to a warehouse you can't reach.",
    "recognises": "Codes you can scan",
    "expires": "expires {{date}}",
    "kind": {
      "product": "Product",
      "lot": "Lot",
      "bin": "Bin",
      "warehouse": "Warehouse",
      "serial": "Serial number"
    },
    "open": {
      "product": "Open product",
      "lot": "Open lot",
      "bin": "Show stock in this bin",
      "warehouse": "Show stock in this warehouse",
      "serial": "Open serial number"
    },
    "button": "Scan",
    "paletteGroup": "Actions",
    "serialStatus": {
      "in_stock": "In stock",
      "in_transit": "On the way",
      "damaged": "Damaged",
      "sold": "Sold",
      "written_off": "Written off",
      "lost": "Lost",
      "returned_to_supplier": "Returned to supplier"
    },
    "matchKind": {
      "variant_barcode": "Product barcode",
      "variant_sku": "Product code",
      "serial_number": "Serial number",
      "lot_barcode": "Batch barcode",
      "lot_number": "Batch number",
      "location_barcode": "Bin barcode",
      "location_code": "Bin code",
      "warehouse_code": "Warehouse code"
    },
    "choice": {
      "title": "Several matches found. Choose the one you meant:"
    }
  },
  "shell": {
    "platform": "Platform",
    "userMenu": "Account menu",
    "search": "Search",
    "searchScoped": "Search across {{scope}}",
    "searchPlatform": "Search groups, companies, operators",
    "searchEmpty": "No destinations match \"{{query}}\".",
    "language": "Language",
    "theme": "Theme",
    "signedInAs": "Signed in as",
    "twoFactor": "Two-factor authentication",
    "accountSettings": "Account settings",
    "signOut": "Sign out",
    "signingOut": "Signing out…",
    "searchHint": "Search screens, actions and records",
    "otherLanguage": "عربي",
    "palette": {
      "screens": "Screens",
      "actions": "Actions",
      "create": "Create",
      "seeAll": "See all results",
      "records": {
        "customers": "Customers",
        "suppliers": "Suppliers",
        "products": "Products",
        "invoices": "Invoices",
        "bills": "Bills",
        "employees": "Employees"
      }
    }
  },
  "rail": {
    "customise": {
      "title": "Customise",
      "tabs": {
        "quick": "Quick access",
        "sections": "Sections"
      }
    },
    "close": "Close",
    "labels": "Left navigation labels",
    "labelsHint": "Turning off labels makes room to see more sections.",
    "resize": "Resize navigation",
    "collapse": "Collapse navigation",
    "expand": "Expand navigation",
    "apps": "Left navigation apps",
    "pin": "Pin {{label}}",
    "show": "Show {{label}}",
    "hide": "Hide {{label}}",
    "pinned": "{{count}} pinned",
    "saveAndClose": "Save and close",
    "lifted": "{{label}} lifted. Use arrow keys to move, space to drop, escape to cancel.",
    "dropped": "{{label}} dropped.",
    "cancelled": "{{label}} cancelled.",
    "unpin": "Unpin {{label}}",
    "quickAccess": {
      "title": "Quick access",
      "add": "Add shortcut",
      "edit": "Edit quick access",
      "empty": "Screens you choose will appear here.",
      "count": "{{count}} of {{max}}",
      "moveUp": "Move {{label}} up",
      "moveDown": "Move {{label}} down",
      "remove": "Remove {{label}}",
      "collapse": "Collapse quick access",
      "expand": "Expand quick access",
      "recent": "Recent"
    },
    "pinnedLabel": "Pinned",
    "more": "More",
    "createDocuments": {
      "invoice": "Invoice",
      "receivePayment": "Receive payment",
      "statement": "Statement",
      "creditNote": "Credit note",
      "salesReceipt": "Sales receipt",
      "refundReceipt": "Refund receipt",
      "expense": "Expense",
      "cheque": "Cheque",
      "bill": "Bill",
      "payBills": "Pay bills",
      "supplierCredit": "Supplier credit",
      "cardCredit": "Card credit",
      "journalEntry": "Journal entry",
      "bankDeposit": "Bank deposit",
      "transfer": "Transfer"
    },
    "admin": {
      "groups": "Groups",
      "onboarding": "Onboard a customer",
      "plans": "Plans",
      "settings": "Settings",
      "holidays": "Holiday calendar",
      "announcements": "Announcements",
      "support": "Support sessions",
      "audit": "Audit",
      "feedback": "Feedback",
      "overview": "Overview",
      "sections": {
        "customers": "Customers",
        "operations": "Operations"
      },
      "noCompanyContext": "No company context"
    },
    "company": {
      "groupConsole": "Group console",
      "modules": "Modules",
      "admin": "Admin",
      "roles": "Roles",
      "members": "Members",
      "dashboard": "Dashboard",
      "workflows": "Workflows",
      "approvals": "Approvals",
      "expandSection": "Expand {{section}}",
      "collapseSection": "Collapse {{section}}",
      "hr": {
        "home": "Overview",
        "reports": "Reports",
        "analytics": "Analytics",
        "settings": "HR settings",
        "employees": "Employees",
        "org": "Organization chart",
        "violations": "Violations",
        "attendance": "Attendance",
        "workingTime": "Working time",
        "attendanceBoard": "Daily attendance",
        "attendanceCorrections": "Attendance requests",
        "leave": "Time off",
        "expenses": "Expenses",
        "cashCustody": "Cash custody",
        "performance": "Performance",
        "assets": "Assets",
        "recruitment": "Recruitment",
        "payrollRuns": "Payroll runs",
        "payrollComponents": "Payroll components",
        "bulkPayrollAssignment": "Bulk component assignment",
        "payrollSettings": "Payroll rules",
        "payslips": "Payslips",
        "salaryAdvances": "Salary advances",
        "fieldSettings": "Custom fields"
      },
      "accounting": {
        "home": "Overview",
        "chart": "Chart of accounts",
        "settings": "Settings",
        "periods": "Fiscal periods",
        "tax": "Tax rates",
        "taxCentre": "Tax centre",
        "journal": "Journal entries",
        "journals": "Journals",
        "trialBalance": "Trial balance",
        "workingCapital": "Working capital",
        "analysisTags": "Analysis tags",
        "costCenters": "Cost centers",
        "reports": "Reports",
        "invoices": "Invoices",
        "salesReceipts": "Sales receipts",
        "customerStatements": "Customer statements",
        "bills": "Bills",
        "spend": "Spend",
        "expenses": "Expenses",
        "payments": "Payments",
        "bankAccounts": "Bank accounts",
        "deposits": "Bank deposits",
        "assets": "Fixed assets",
        "depreciation": "Depreciation run",
        "reconciliation": "Bank reconciliation",
        "budgets": "Budgets",
        "openingBalances": "Opening balances",
        "paymentTerms": "Payment terms",
        "closeBooks": "Close the books",
        "recurringTemplates": "Recurring templates",
        "cashPosition": "Cash position",
        "cheques": "Cheques",
        "supplierStatement": "Statement",
        "payrollPayments": "Payroll payments"
      },
      "companies": "Entities",
      "departments": "Departments",
      "branches": "Branches",
      "positions": "Positions",
      "sequences": "Numbering",
      "settings": "Company settings",
      "notificationSettings": "Notification settings",
      "alertRules": "Alert rules",
      "audit": "Audit trail",
      "sections": {
        "configure": "Configure",
        "organisation": "Organisation",
        "directory": "Directory",
        "hr": "Human resources",
        "inventory": "Inventory",
        "purchasing": "Purchasing",
        "sales": "Sales",
        "accounting": "Accounting"
      },
      "groups": {
        "people": "People",
        "time": "Time",
        "pay": "Pay",
        "talent": "Talent",
        "reports": "Reports",
        "setup": "Setup",
        "stock": "Stock on hand",
        "batches": "Lots & expiry",
        "sales": "Sales",
        "purchases": "Purchases",
        "expenses": "Expenses",
        "receivables": "Receivables",
        "payables": "Payables",
        "banking": "Banking",
        "ledger": "Ledger",
        "periodClose": "Period close",
        "assets": "Assets",
        "operations": "Operations"
      },
      "inventory": {
        "overview": "Overview",
        "stock": "Stock on hand",
        "movements": "Movements",
        "adjustments": "Adjustments",
        "disposals": "Write-offs",
        "lots": "Lots & expiry",
        "reports": "Inventory analysis",
        "warehouses": "Warehouses",
        "locations": "Locations",
        "access": "Access",
        "transfers": "Transfers",
        "counts": "Counts",
        "serials": "Serial numbers",
        "newTransfer": "New transfer"
      },
      "purchasing": {
        "orders": "Purchase orders",
        "receipts": "Goods receipts",
        "debitNotes": "Debit notes",
        "paymentsMade": "Payments made",
        "apAging": "AP aging",
        "returns": "Returns",
        "threeWayMatch": "Three-way match",
        "goodsReceivedNotInvoiced": "Received, not invoiced",
        "landedCosts": "Landed costs",
        "landedCostsPending": "Landed costs pending",
        "landedCostCategories": "Landed-cost categories",
        "overview": "Overview",
        "newOrder": "New purchase order",
        "newLandedCost": "New landed cost"
      },
      "sales": {
        "overview": "Overview",
        "orders": "Quotations and orders",
        "creditNotes": "Credit notes",
        "paymentsReceived": "Payments received",
        "reservations": "Reservations",
        "returns": "Returns",
        "trend": "Sales trend",
        "arAging": "AR aging",
        "newOrder": "New sales order"
      }
    },
    "spine": {
      "label": "Main navigation"
    }
  },
  "companySwitcher": {
    "trigger": "Switch company",
    "group": "Group",
    "subsidiaries": "Subsidiaries",
    "search": "Search entities",
    "noResults": "No matching entities",
    "active": "Active",
    "select": "Select {{code}}",
    "manage": "Manage entities",
    "emptyGroup": "No entities yet",
    "shortcutHint": "to switch",
    "meta": "{{currency}} · {{role}}",
    "subsidiariesCount_one": "{{count}} entity",
    "subsidiariesCount_other": "{{count}} entities"
  },
  "customer": {
    "detailsDescription": "Identity, tax and payment terms.",
    "contactsDescription": "People to reach at this customer.",
    "tagsDescription": "Labels for grouping and filtering.",
    "title": "Customers",
    "countLabel_one": "{{count}} customer",
    "countLabel_other": "{{count}} customers",
    "subtitle": "Manage customer directory, contacts, and tags.",
    "create": "New customer",
    "edit": "Edit customer",
    "details": "Customer details",
    "detailSubtitle": "Customer record {{code}}",
    "columnsMenu": {
      "label": "Columns",
      "description": "Show or hide columns"
    },
    "deactivate": "Deactivate customer",
    "deactivateConfirmation": "Are you sure you want to deactivate customer {{code}}? Deactivated customers cannot place new orders.",
    "activate": "Reactivate customer",
    "code": "Customer code",
    "name": "Customer name",
    "nameEn": "Name (English)",
    "nameAr": "Name (Arabic)",
    "type": "Customer type",
    "typeCompany": "Company",
    "typeIndividual": "Individual",
    "address": "Address",
    "addressSection": "Structured address",
    "addressEn": "Address (English)",
    "addressAr": "Address (Arabic)",
    "identitySection": "Identity",
    "contactSection": "Primary contact",
    "contactOptional": "Optional — add a primary contact after saving the customer.",
    "billingSection": "Billing and tax",
    "internalSection": "Internal settings",
    "receiver_type": "Receiver type",
    "governorate": "Governorate",
    "city": "City",
    "street": "Street",
    "building_number": "Building number",
    "mobile": "Mobile",
    "till_note": "Till note",
    "isWalkIn": "Walk-in customer",
    "country": "Country",
    "taxIdentifier": "Tax identifier / VAT number",
    "paymentTerms": "Payment terms",
    "paymentTermsNone": "None",
    "defaultCurrency": "Default currency",
    "optional": "optional",
    "invalidForm": "Complete the highlighted required fields before saving.",
    "taxTreatment": "Tax treatment",
    "salesperson": "Salesperson",
    "department": "Department",
    "isIntercompany": "Intercompany customer",
    "targetCompany": "Target intercompany",
    "status": "Status",
    "active": "Active",
    "inactive": "Inactive",
    "allTypes": "All types",
    "allStatuses": "All statuses",
    "allTags": "All tags",
    "contacts": "Contacts",
    "addContact": "Add contact",
    "tags": "Tags",
    "attachTag": "Attach tag",
    "detachTag": "Remove tag",
    "noContacts": "No contacts added yet.",
    "noContactsDescription": "Add a contact so invoices and statements have someone to address.",
    "noTags": "No tags attached.",
    "createSuccess": "Customer created successfully.",
    "updateSuccess": "Customer updated successfully.",
    "activateSuccess": "Customer reactivated.",
    "deactivateSuccess": "Customer deactivated successfully.",
    "contactAdded": "Contact added successfully.",
    "contactRemoved": "Contact removed successfully.",
    "tagAttached": "Tag attached successfully.",
    "tagDetached": "Tag removed successfully.",
    "backToList": "Back to customers",
    "outstandingBalance": "Outstanding balance",
    "primaryContact": "Primary contact",
    "lastActivity": "Last activity",
    "financialSummary": {
      "title": "Financial summary",
      "balance": "Balance",
      "overdue": "Overdue",
      "unapplied": "Unapplied receipts",
      "lastPayment": "Last payment",
      "loadError": "The financial summary could not be loaded."
    },
    "hub": {
      "tabsLabel": "Customer sections",
      "tabs": {
        "overview": "Overview",
        "invoices": "Invoices",
        "payments": "Payments received",
        "statement": "Statement"
      },
      "invoicesEmpty": "No invoices for this customer",
      "invoicesEmptyDescription": "Invoices issued to this customer will appear here.",
      "paymentsEmpty": "No payments received yet",
      "paymentsEmptyDescription": "Payments received from this customer will appear here.",
      "statementEmpty": "No statement entries",
      "statementEmptyDescription": "This customer's statement has no entries for this period.",
      "statementFrom": "From",
      "statementTo": "To",
      "openingBalance": "Opening balance",
      "invoicesLoadError": "This customer's invoices could not be loaded.",
      "paymentsLoadError": "Payments could not be loaded.",
      "statementLoadError": "This customer's statement could not be loaded.",
      "draft": "Draft",
      "columns": {
        "document": "Document",
        "date": "Date",
        "dueDate": "Due date",
        "amountDue": "Amount due",
        "reference": "Reference",
        "amount": "Amount",
        "type": "Type",
        "description": "Description",
        "paid": "Paid",
        "balance": "Balance"
      }
    },
    "emptyTitle": "No customers yet",
    "emptyBody": "Create your first customer to raise invoices and track what they owe.",
    "noResultsTitle": "No customers match these filters",
    "noResultsBody": "Try a different search term, or clear the filters to see every customer.",
    "validation": {
      "nameRequired": "Enter a customer name.",
      "addressRequired": "Enter a customer address.",
      "countryRequired": "Select a country.",
      "contactNameRequired": "Enter the contact name.",
      "emailInvalid": "Enter a valid email address."
    }
  },
  "supplier": {
    "detailsDescription": "Identity, tax and payment terms.",
    "contactsDescription": "People to reach at this supplier.",
    "tagsDescription": "Labels for grouping and filtering.",
    "title": "Suppliers",
    "countLabel_one": "{{count}} supplier",
    "countLabel_other": "{{count}} suppliers",
    "subtitle": "Manage supplier directory, contacts, and tags.",
    "create": "New supplier",
    "edit": "Edit supplier",
    "details": "Supplier details",
    "deactivate": "Deactivate supplier",
    "deactivateConfirmation": "Are you sure you want to deactivate supplier {{code}}? New purchase orders cannot be issued to a deactivated supplier.",
    "activate": "Reactivate supplier",
    "code": "Supplier code",
    "name": "Supplier name",
    "nameEn": "Name (English)",
    "nameAr": "Name (Arabic)",
    "address": "Address",
    "addressEn": "Address (English)",
    "addressAr": "Address (Arabic)",
    "country": "Country",
    "taxIdentifier": "Tax identifier / VAT number",
    "paymentTerms": "Payment terms",
    "paymentTermsNone": "None",
    "defaultCurrency": "Default currency",
    "optional": "optional",
    "department": "Department",
    "isIntercompany": "Intercompany supplier",
    "targetCompany": "Target intercompany",
    "status": "Status",
    "active": "Active",
    "inactive": "Inactive",
    "allStatuses": "All statuses",
    "contacts": "Contacts",
    "addContact": "Add contact",
    "tags": "Tags",
    "attachTag": "Attach tag",
    "detachTag": "Remove tag",
    "noContacts": "No contacts added yet.",
    "noContactsDescription": "Add a contact so purchase orders and remittances have someone to address.",
    "noTags": "No tags attached.",
    "saveErrorTitle": "The supplier was not saved",
    "saveErrorFields": "Check these and save again:",
    "createSuccess": "Supplier created successfully.",
    "updateSuccess": "Supplier updated successfully.",
    "activateSuccess": "Supplier reactivated.",
    "deactivateSuccess": "Supplier deactivated successfully.",
    "contactAdded": "Contact added successfully.",
    "contactRemoved": "Contact removed successfully.",
    "tagAttached": "Tag attached successfully.",
    "tagDetached": "Tag removed successfully.",
    "backToList": "Back to suppliers",
    "hub": {
      "tabsLabel": "Supplier sections",
      "tabs": {
        "overview": "Overview",
        "products": "Products",
        "bills": "Bills",
        "payments": "Payments made"
      },
      "billsEmpty": "No bills from this supplier",
      "billsEmptyDescription": "Bills you record from this supplier will appear here.",
      "paymentsEmpty": "No payments made yet",
      "paymentsEmptyDescription": "Payments you make to this supplier will appear here.",
      "billsLoadError": "This supplier's bills could not be loaded.",
      "paymentsLoadError": "Payments could not be loaded.",
      "draft": "Draft",
      "columns": {
        "document": "Document",
        "reference": "Supplier reference",
        "date": "Date",
        "dueDate": "Due date",
        "amountDue": "Amount due",
        "amount": "Amount"
      }
    },
    "primaryContact": "Primary contact",
    "lastActivity": "Last activity",
    "emptyTitle": "No suppliers yet",
    "emptyBody": "Create your first supplier to record bills and track what you owe.",
    "noResultsTitle": "No suppliers match these filters",
    "noResultsBody": "Try a different search term, or clear the filters to see every supplier.",
    "validation": {
      "codeRequired": "Enter a supplier code.",
      "nameEnRequired": "Enter the supplier's English name.",
      "nameArRequired": "Enter the supplier's Arabic name.",
      "countryRequired": "Select a country.",
      "contactNameRequired": "Enter the contact name.",
      "emailInvalid": "Enter a valid email address."
    }
  },
  "product": {
    "detailsDescription": "What it is and how it is counted.",
    "pricesDescription": "What it sells and costs for, with tax.",
    "partNumber": "Part number",
    "partNumberHelper": "The maker's or supplier's number for this item. Optional; two items may share one.",
    "title": "Products",
    "countLabel_one": "{{count}} product",
    "countLabel_other": "{{count}} products",
    "subtitle": "Manage product catalog, pricing, and stock status.",
    "create": "New product",
    "edit": "Edit product",
    "quickCreateHelp": "Start with the essentials to create this product. You can add optional details later.",
    "fieldLegend": "Field guide",
    "required": "required",
    "optional": "optional",
    "hintLabel": "More information",
    "essentials": "Essentials",
    "optionalDetails": "Optional details",
    "details": "Product details",
    "deactivate": "Deactivate product",
    "deactivateConfirmation": "Are you sure you want to deactivate product {{sku}}? Discontinued products cannot be selected in new sales orders.",
    "sku": "SKU",
    "skuHelper": "Leave this empty to generate one automatically.",
    "name": "Product name",
    "nameEn": "Name (English)",
    "nameAr": "Name (Arabic)",
    "nameHelper": "Provide the name in at least one language (English or Arabic).",
    "description": "Description",
    "descriptionEn": "Description (English)",
    "descriptionAr": "Description (Arabic)",
    "type": "Product type",
    "typeStockable": "Storable",
    "typeConsumable": "Consumable",
    "typeService": "Service",
    "typeStockableHint": "A physical item held as inventory and available for sale.",
    "typeConsumableHint": "A physical item used or consumed without stock tracking.",
    "typeServiceHint": "Work or time sold without inventory.",
    "category": "Category",
    "selectCategory": "Select category",
    "unitOfMeasure": "Unit of measure",
    "selectUnitOfMeasure": "Select unit of measure",
    "salesPrice": "Sales price",
    "salesPriceCurrency": "Sales currency",
    "costPrice": "Cost price",
    "costPriceCurrency": "Cost currency",
    "taxRate": "Tax rate (%)",
    "status": "Status",
    "statusActive": "Active",
    "statusDiscontinued": "Discontinued",
    "allTypes": "All types",
    "allStatuses": "All statuses",
    "allCategories": "All categories",
    "prices": "Product prices",
    "setPrice": "Set price",
    "setPriceTitle": "Set product price",
    "setPriceDescription": "Set a specific price for a currency or price list.",
    "price": "Price",
    "currency": "Currency",
    "priceList": "Price list ID",
    "noPrices": "No custom prices configured.",
    "createSuccess": "Product created successfully.",
    "updateSuccess": "Product updated successfully.",
    "activateSuccess": "Product reactivated.",
    "activate": "Reactivate product",
    "deactivateSuccess": "Product deactivated successfully.",
    "priceSetSuccess": "Product price saved successfully.",
    "backToList": "Back to products",
    "emptyTitle": "No products yet",
    "emptyBody": "Add your first product or service so it can be used on invoices and bills.",
    "noResultsTitle": "No products match these filters",
    "noResultsBody": "Try a different search term, or clear the filters to see every product.",
    "additionalDetails": "Additional details",
    "itemCodeType": "Item coding scheme",
    "selectItemCodeType": "Select coding scheme",
    "itemCodeTypeNone": "Not specified",
    "itemCode": "Item code",
    "etaUnitType": "ETA unit type",
    "etaUnitTypePlaceholder": "e.g. PCE or KGM",
    "etaUnitTypeHelp": "Enter the e-invoice unit code used for this product.",
    "department": "Department",
    "selectDepartment": "Select department",
    "departmentNone": "No department",
    "validation": {
      "nameRequired": "Enter a product name in English or Arabic.",
      "unitRequired": "Select a unit of measure.",
      "amountInvalid": "Enter an amount, for example 100 or 100.50.",
      "taxRateInvalid": "Enter a percentage, for example 14 or 14.5.",
      "pricePositive": "Enter a price above zero."
    },
    "costing": {
      "computedHint": "Computed from stock on hand",
      "standardNoPermission": "Only people allowed to edit standard costs can change it.",
      "confirmTitle": "Save these costing changes?",
      "standardTitle": "Standard cost change",
      "standardDescription": "The stock on hand is revalued at the new standard cost when you save.",
      "onHand": "Stock on hand",
      "oldCost": "Current standard cost",
      "newCost": "New standard cost",
      "revaluation": "Revaluation (preview)",
      "previewNote": "This is a preview. The revaluation is calculated and posted when you save.",
      "stockLoading": "Loading stock on hand",
      "stockError": "Stock on hand could not be loaded. The revaluation is still calculated when you save.",
      "categoryMoveTitle": "Costing method change",
      "categoryMoveBody": "This product's stock will move from {{from}} to {{to}}.",
      "categoryMoveStandard": "Its stock is revalued to its standard cost, and the difference posts to the price difference account.",
      "confirmAction": "Save changes",
      "forbidden": "You do not have permission to make this costing change.",
      "saveErrorTitle": "The product was not saved"
    }
  },
  "category": {
    "title": "Product categories",
    "subtitle": "Manage hierarchical product categories and parent relationships.",
    "create": "New category",
    "edit": "Edit category",
    "details": "Category details",
    "deactivate": "Deactivate category",
    "deactivateConfirmation": "Are you sure you want to deactivate category {{code}}? Deactivated categories cannot be assigned to new products.",
    "code": "Category code",
    "name": "Category name",
    "nameEn": "Name (English)",
    "nameAr": "Name (Arabic)",
    "parent": "Parent category",
    "noParent": "None (root category)",
    "selectParent": "Select parent category",
    "changeParent": "Change parent",
    "changeParentTitle": "Change parent category",
    "changeParentDescription": "Select a new parent category for {{code}}.",
    "salesTax": "Sales tax",
    "purchaseTax": "Purchase tax",
    "noTax": "No tax",
    "taxSearch": "Search tax rates",
    "taxNoResults": "No tax rate matches this search.",
    "taxRemove": "Remove tax rate",
    "taxHint": "Used for products in this category unless a customer, supplier or product has its own rate.",
    "taxReadOnlyHint": "Only people allowed to manage tax rates can change this.",
    "taxLoading": "Loading tax rates…",
    "taxLoadError": "Could not load tax rates. Try again.",
    "status": "Status",
    "active": "Active",
    "inactive": "Inactive",
    "allStatuses": "All statuses",
    "treeView": "Tree view",
    "listView": "List view",
    "rowActions": "Category actions",
    "expandAll": "Expand all",
    "collapseAll": "Collapse all",
    "noCategories": "No product categories found.",
    "noCategoriesDescription": "Categories group products for reporting and defaults. Create your first category to get started.",
    "noSearchMatches": "No categories match \"{{query}}\".",
    "count": "{{visible}} of {{total}} categories",
    "createSuccess": "Category created successfully.",
    "updateSuccess": "Category updated successfully.",
    "activateSuccess": "Category reactivated.",
    "activate": "Reactivate category",
    "deactivateSuccess": "Category deactivated successfully.",
    "parentSuccess": "Parent category updated successfully.",
    "backToList": "Back to categories",
    "optional": "optional",
    "validation": {
      "codeRequired": "Enter a category code.",
      "nameRequired": "Enter a category name in English or Arabic."
    },
    "costing": {
      "method": "Costing method",
      "methodHint": "How stock in this category is valued. Keep the company default unless this category needs its own method.",
      "inherit": "Company default",
      "methods": {
        "standard": "Standard cost",
        "average": "Weighted average",
        "fifo": "First in, first out (FIFO)"
      },
      "readOnlyHint": "Only people allowed to change costing methods can edit this.",
      "priceDifferenceAccount": "Price difference account",
      "priceDifferenceHint": "Receives the difference between a supplier's price and the standard cost. Leave it empty to use the company's account.",
      "priceDifferenceDefault": "Company default account",
      "useDefaultAccount": "Use the default account",
      "accountSearch": "Search accounts",
      "accountEmpty": "No account matches this search.",
      "confirmTitle": "Change the costing method?",
      "confirmBody": "Products in this category that hold stock will move to {{method}}. Their stock value stays the same.",
      "confirmBodyStandard": "Products in this category that hold stock will be revalued to their standard cost. The difference posts to the price difference account.",
      "confirmAction": "Change method",
      "saveErrorTitle": "The category was not saved",
      "forbidden": "You do not have permission to change the costing method."
    }
  },
  "contact": {
    "name": "Contact name",
    "role": "Role / position",
    "phone": "Phone number",
    "email": "Email address",
    "isPrimary": "Primary contact",
    "primary": "Primary",
    "addTitle": "Add contact",
    "addDescription": "Add a new contact person for this customer."
  },
  "phoneField": {
    "country": "Country",
    "internationalHint": "Number includes its country code"
  },
  "currencyField": {
    "placeholder": "Choose a currency",
    "search": "Search currencies",
    "noResults": "No currency matches this search."
  },
  "countryField": {
    "placeholder": "Choose a country",
    "search": "Search countries",
    "noResults": "No country matches this search."
  },
  "tag": {
    "selectTag": "Select a tag to attach",
    "title": "Directory tags",
    "subtitle": "Manage company-wide classification tags for customers and suppliers.",
    "create": "New tag",
    "edit": "Edit tag",
    "delete": "Delete tag",
    "deleteConfirmation": "Are you sure you want to delete tag \"{{name}}\"? It will be unattached from all customers and suppliers.",
    "name": "Tag name",
    "namePlaceholder": "e.g. VIP, Wholesale",
    "noTags": "No directory tags found.",
    "emptyBody": "Tags classify customers and suppliers across the directory. Create your first tag to get started.",
    "noResultsTitle": "No tags match this search",
    "noResultsBody": "Try a different term, or clear the search.",
    "createSuccess": "Tag created successfully.",
    "updateSuccess": "Tag renamed successfully.",
    "deleteSuccess": "Tag deleted successfully.",
    "validation": {
      "nameRequired": "Enter a tag name."
    }
  },
  "auth": {
    "signInTitle": "Sign in",
    "signInSubtitle": "Sign in to the companies your administrator gave you.",
    "email": "Email",
    "phone": "Phone",
    "login": "Email or phone",
    "password": "Password",
    "signingIn": "Signing in…",
    "forgotPasswordLink": "Forgot your password?",
    "backToSignIn": "Back to sign in",
    "twoFactor": {
      "title": "Two-factor verification",
      "subtitle": "Enter the 6-digit code from your authenticator app, or one of your recovery codes.",
      "code": "Authentication code",
      "recoveryCode": "Recovery code",
      "useRecoveryCode": "Use a recovery code instead",
      "useAuthenticatorCode": "Use an authenticator code instead",
      "verifying": "Verifying…",
      "verify": "Verify",
      "recoverySubtitle": "Enter one of the recovery codes you saved at enrolment.",
      "lostDevice": "Lost your device?",
      "haveAuthenticator": "Have your authenticator?",
      "noChallenge": "If you have not just entered your password, sign in first."
    },
    "forgotPassword": {
      "title": "Reset your password",
      "subtitle": "Enter the email you sign in with. We will send a link to choose a new password.",
      "sendLink": "Send reset link",
      "sending": "Sending…",
      "emailSent": "If an account exists for that email, a reset link is on its way.",
      "phoneResetHint": "If you sign in with a phone number, ask your HR administrator for a reset code.",
      "resetCodeLink": "I have a reset code from HR"
    },
    "resetCode": {
      "title": "Use a reset code",
      "subtitle": "Enter the code from HR to choose a new password.",
      "identifier": "Email or phone",
      "code": "Reset code",
      "newPassword": "New password",
      "confirmation": "Confirm new password",
      "submit": "Change password",
      "submitting": "Changing password…",
      "success": "Your password was changed. Sign in with the new password."
    },
    "activate": {
      "title": "Activate your account",
      "intro": "Enter the code from the card HR gave you.",
      "code": "Activation code",
      "phone": "Phone number",
      "password": "New password",
      "confirmation": "Confirm new password",
      "currentPassword": "Current password",
      "existingAccount": "You already have an account. Enter your current password to join this company.",
      "submit": "Activate account",
      "submitting": "Activating…",
      "success": "Your account is active. Sign in with your phone number."
    },
    "resetPassword": {
      "title": "Choose a new password",
      "subtitle": "Enter the new password for your account.",
      "newPassword": "New password",
      "newPasswordConfirmation": "Confirm new password",
      "reset": "Reset password",
      "resetting": "Resetting…",
      "success": "Your password has been reset. You can now sign in.",
      "passwordMinLength": "Password must be at least 8 characters.",
      "passwordConfirmationMatch": "Passwords do not match."
    },
    "invitationAccept": {
      "title": "Accept your invitation",
      "subtitle": "Set your name and a password to join the organisation.",
      "name": "Full name",
      "password": "Password",
      "passwordConfirmation": "Confirm password",
      "submit": "Accept invitation",
      "submitting": "Accepting…",
      "missingLink": "This invitation link is incomplete. Contact your administrator for a new one."
    },
    "twoFactorSetup": {
      "title": "Set up two-factor authentication",
      "subtitle": "Scan the QR code with your authenticator app, then enter the 6-digit code to confirm.",
      "stepConfirmPassword": "Confirm your password to continue.",
      "password": "Password",
      "confirm": "Confirm",
      "stepScan": "Scan this QR code with your authenticator app",
      "code": "Code from app",
      "enable": "Enable two-factor",
      "enabling": "Enabling…",
      "stepRecovery": "Save your recovery codes",
      "recoverySubtitle": "Each code can be used once if you lose access to your authenticator. Store them somewhere safe.",
      "download": "Download",
      "copy": "Copy",
      "copied": "Copied",
      "done": "Done",
      "secretLabel": "Or enter this key manually:",
      "invalidSecret": "Could not load the QR code. Try again."
    },
    "errors": {
      "invalidCredentials": "Email or password is incorrect.",
      "rateLimited": "Too many attempts. Wait a minute and try again.",
      "recoveryCodeInvalid": "That code is not valid.",
      "twoFactorInvalid": "The code you entered is not valid."
    },
    "signInEyebrow": "Company sign-in",
    "welcomeBack": "Welcome back",
    "emailPlaceholder": "you@company.com",
    "loginPlaceholder": "Email or phone number",
    "togglePassword": "Show or hide the password",
    "show": "Show",
    "hide": "Hide",
    "provisionedNote": "Accounts are created by your company’s administrator.",
    "operatorEyebrow": "Platform operator",
    "operatorEmail": "Operator email",
    "twoFactorMandatory": "Two-factor authentication is mandatory on this side and cannot be turned off.",
    "continueToTwoFactor": "Continue to two-factor",
    "devLogin": "Dev login",
    "noSelfRegistration": "Operator accounts are created by another operator, never self-registered.",
    "hero": {
      "tag": "multi-company",
      "headlineLead": "One login.",
      "headlineRest": "Every company.",
      "headlineBody": "Keep each company's books separate while managing everything from one workspace.",
      "sampleLabel": "Sample ledger · illustration only",
      "sampleCompanyLabel": "Company",
      "sampleCompany": "Northstar Holdings",
      "sampleContext": "FY 2026 · USD",
      "trialBalance": "Trial balance",
      "debits": "Debits",
      "credits": "Credits",
      "difference": "Difference",
      "balanced": "BALANCED",
      "capabilities": "Multi-company · Multi-currency · Accounting · HR · Operations",
      "privacy": "Each company's books stay separate and private.",
      "operatorsOnly": "operators only",
      "platformHeadline": "You operate the platform. You do not read their books.",
      "platformBody": "Operators administer groups, plans and support access. Opening a support session into a customer group is recorded, and the customer can see it on their own audit screen.",
      "twoFactorMandatory": "Two-factor authentication is mandatory here and cannot be turned off."
    }
  },
  "account": {
    "title": "Your account",
    "subtitle": "Your profile, your password and what you get notified about.",
    "tabs": {
      "profile": "Profile",
      "security": "Security",
      "notifications": "Notifications"
    },
    "avatar": {
      "title": "Photo",
      "upload": "Upload a photo",
      "remove": "Remove",
      "hint": "JPEG, PNG or WebP, up to 2 MB. We crop it to a square and keep two small copies; the file you upload is not stored. Your photo is visible to people in your company group."
    },
    "profile": {
      "title": "You",
      "name": "Name",
      "email": "Email",
      "noEmail": "No email",
      "loginPhone": "Login phone",
      "notSet": "Not set",
      "emailFixed": "Your email address is your sign-in and cannot be changed here. Ask an administrator.",
      "verified": "Verified",
      "unverified": "Not verified",
      "saved": "Saved.",
      "error": "Could not load your profile.",
      "errors": {
        "name": "Name must be at least 2 characters."
      },
      "languageTitle": "Language",
      "languageNote": "Saved to your account, so it follows you to another device.",
      "languageNotSaved": "The language changed on this device but could not be saved to your account.",
      "deviceTitle": "This device",
      "deviceNote": "Theme is remembered for this browser only.",
      "timePreferencesTitle": "Time and timezone",
      "timePreferencesNote": "Choose how timestamps and times appear throughout your workspace.",
      "timezone": "Timezone",
      "timezoneBrowser": "Use this device's timezone",
      "timeFormat": "Time format",
      "timeFormat12": "12-hour (AM/PM)",
      "timeFormat24": "24-hour",
      "timePreferencesSaving": "Saving…"
    },
    "email": {
      "change": "Change email",
      "dialogTitle": "Change your email",
      "dialogBody": "We will send a confirmation link to the new address. Your email changes only after you open that link. We will also tell your current address that you asked for this.",
      "pending": "Waiting for confirmation at {{email}}. Open the link we sent to finish the change.",
      "changed": "Your email address has changed.",
      "expired": "That confirmation link has expired or was already used.",
      "taken": "That address is no longer available. Request another change."
    },
    "loginPhone": {
      "change": "Change",
      "changeButton": "Change login phone",
      "removeButton": "Remove login phone",
      "changeDescription": "You will sign in with this number. Ask HR for a code issued for this exact number, then enter it with your current password.",
      "code": "Code from HR",
      "codeError": "Check the code and the number. HR issues a code for one number only.",
      "removeDescription": "You will sign in with your email only. Enter your current password to confirm.",
      "remove": "Remove",
      "removeEmail": "Remove email",
      "changeTitle": "Change your login phone",
      "removeTitle": "Remove your login phone",
      "removeEmailTitle": "Remove your email",
      "currentPassword": "Current password",
      "save": "Save phone",
      "success": "Your login phone has been updated.",
      "removed": "Your login phone has been removed.",
      "emailRemoved": "Your email has been removed."
    },
    "security": {
      "passwordTitle": "Change password",
      "twoFactorTitle": "Two-factor authentication",
      "passwordBody": "Choose a password you do not use anywhere else. You stay signed in on this device.",
      "currentPassword": "Current password",
      "newPassword": "New password",
      "confirmPassword": "Confirm password",
      "passwordChanged": "Your password has changed.",
      "errors": {
        "required": "This field is required.",
        "minLength": "Password must be at least 8 characters.",
        "mismatch": "Passwords do not match.",
        "generic": "Could not change your password."
      }
    },
    "sessions": {
      "title": "Where you are signed in",
      "body": "Manage the active browsers and devices currently signed in to your account.",
      "device": "Device",
      "ipAddress": "IP address",
      "lastActive": "Last active",
      "thisDevice": "this device",
      "currentSessionBadge": "Current session",
      "revoke": "End session",
      "endOthers": "End all other sessions",
      "singleSessionNotice": "You are currently only signed in on this device. No other active sessions were detected.",
      "revokeDialogTitle": "End session",
      "revokeDialogBody": "Are you sure you want to end this session? That device will be signed out immediately.",
      "endOthersDialogTitle": "End all other sessions",
      "endOthersDialogBody": "Are you sure you want to end all other sessions? Every browser and device except this one will be signed out immediately."
    }
  },
  "dashboard": {
    "title": "Dashboard",
    "pulse": {
      "loading": "Loading the dashboard",
      "lastMonth": "{{month}}: {{value}}",
      "vsPreviousPeriod": "vs the same days last month",
      "noPrior": "No prior figure",
      "total": "Total",
      "tiles": {
        "revenue": "Revenue · month to date",
        "expenses": "Expenses · month to date",
        "netResult": "Net result · month to date",
        "cash": "Cash",
        "cashAccounts_one": "{{count}} account",
        "cashAccounts_other": "{{count}} accounts",
        "sales": "Sales · month to date",
        "orders": "Orders · month to date",
        "averageOrder": "Average order · month to date",
        "headcount": "Headcount",
        "joinedThisMonth_one": "{{count}} joined this month",
        "joinedThisMonth_other": "{{count}} joined this month",
        "leaveWaiting": "Leave requests waiting",
        "claimsWaiting": "Expense claims to review",
        "awaitingDecision": "Awaiting a decision",
        "departments": "Departments",
        "largestDepartment": "Largest: {{name}}",
        "stockValue": "Stock value",
        "items_one": "{{count}} item",
        "items_other": "{{count}} items",
        "stockIssued": "Stock issued · this month",
        "received": "{{value}} received",
        "belowMinimum": "Below minimum",
        "toReorder": "Items to reorder",
        "outOfStock": "Out of stock",
        "itemsOut": "Items with no stock"
      },
      "series": {
        "month": "Month",
        "revenue": "Revenue",
        "expenses": "Expenses",
        "netResult": "Net result",
        "partial": "This month so far",
        "sales": "Sales",
        "headcount": "Headcount",
        "joiners": "Joiners",
        "leavers": "Leavers",
        "received": "Received",
        "issued": "Issued"
      },
      "panels": {
        "monthlyResult": "Monthly revenue and expenses",
        "monthlyResultCaption": "This month to date · revenue {{revenue}} · expenses {{expenses}} · net result {{netResult}}",
        "profitAndLossLink": "Open the profit and loss report",
        "whoOwesWhom": "Who owes whom",
        "customersOweUs": "Customers owe us",
        "weOweSuppliers": "We owe suppliers",
        "overdue": "{{value}} overdue",
        "agingLink": "Open the aging report",
        "spending": "Where the money went · this year",
        "monthlySales": "Monthly sales",
        "salesLink": "Open the sales overview",
        "topCustomers": "Top customers · this month",
        "salesByCategory": "Sales by category · this month",
        "headcount": "Headcount, joiners and leavers",
        "peopleLink": "Open the employee list",
        "peopleByDepartment": "People by department",
        "stockMovement": "Stock received and issued",
        "inventoryLink": "Open the inventory overview",
        "stockByCategory": "Stock value by category"
      },
      "aging": {
        "current": "Not due",
        "days_1_30": "1–30 days",
        "days_31_60": "31–60 days",
        "days_61_90": "61–90 days",
        "days_over_90": "Over 90 days"
      },
      "start": {
        "accounting": {
          "title": "Accounting",
          "body": "Post your first invoice or bill to see your money here.",
          "cta": "Open accounting"
        },
        "sales": {
          "title": "Sales",
          "body": "Confirm your first sales order to see sales by month.",
          "cta": "Open sales"
        },
        "hr": {
          "title": "People",
          "body": "Add your first employee to see headcount and departments.",
          "cta": "Open HR"
        },
        "inventory": {
          "title": "Inventory",
          "body": "Receive your first stock to see its value and movement.",
          "cta": "Open inventory"
        }
      },
      "error": "These figures could not be loaded."
    },
    "placeholder": "Nothing here yet. Modules arrive with the next plan.",
    "greeting": "Good morning, {{name}}",
    "greetingAfternoon": "Good afternoon, {{name}}",
    "greetingEvening": "Good evening, {{name}}",
    "greetingRamadan": "Ramadan Kareem, {{name}}",
    "greetingEid": "Eid Mubarak, {{name}}",
    "scope": "{{group}} · {{company}}",
    "scopeUnknown": "No active company",
    "header": {
      "memberships": "Your memberships · {{company}}",
      "groupMemberships": "Group memberships"
    },
    "stats": {
      "entities": "Entities",
      "members": "Members · this company",
      "allActive": "all active",
      "roles": "Roles",
      "roleSplit": "{{builtIn}} built-in, {{custom}} custom",
      "grants": "Your grants · this company",
      "grantsNote": "of the permission catalogue",
      "suspendedCount_one": "{{count}} suspended",
      "suspendedCount_other": "{{count}} suspended"
    },
    "entities": {
      "title": "Entities",
      "meta": "companies you are a member of",
      "code": "Code",
      "country": "Country",
      "countryPlaceholder": "Choose a country",
      "entity": "Entity",
      "currency": "Currency",
      "yourRole": "Your role",
      "customRole": "Custom role",
      "total": "Total",
      "count_one": "{{count}} entity",
      "count_other": "{{count}} entities"
    },
    "waiting": {
      "title": "Waiting on you",
      "count_one": "{{count}} item",
      "count_other": "{{count}} items",
      "leave": "Time off",
      "expenses": "Expense claims",
      "reviews": "Draft reviews",
      "assets": "Assets needing attention",
      "link": "Open the queue",
      "emptyTitle": "Nothing waiting",
      "emptyBody": "Nothing needs your decision right now."
    },
    "audit": {
      "title": "Recent administration",
      "meta": "audit trail",
      "emptyTitle": "No events yet",
      "emptyBody": "Administration events appear here once they are recorded.",
      "link": "Open the audit trail"
    },
    "attention": {
      "overdueReceivables": "Overdue receivables",
      "overdueCount_zero": "{{count}} invoices past due",
      "overdueCount_one": "{{count}} invoice past due",
      "overdueCount_other": "{{count}} invoices past due",
      "overdueNone": "Nothing past due",
      "billsDueWeek": "Bills due this week",
      "billsDueCount_zero": "{{count}} bills due by {{date}}",
      "billsDueCount_one": "{{count}} bill due by {{date}}",
      "billsDueCount_other": "{{count}} bills due by {{date}}",
      "billsDueNone": "Nothing due this week",
      "approvalsWaiting": "Approvals waiting",
      "approvalsNote": "awaiting your decision",
      "approvalsNone": "Nothing waiting",
      "draftInvoices": "Draft invoices",
      "draftBills": "Draft bills",
      "draftNote": "awaiting confirmation",
      "draftNone": "No drafts",
      "groups": {
        "accounting": "Accounting",
        "people": "People"
      },
      "allClear": "All clear",
      "errorHint": "Could not load",
      "leaveRequests": "Open leave requests",
      "leaveRequestsCount_zero": "{{count}} pending",
      "leaveRequestsCount_one": "{{count}} request pending",
      "leaveRequestsCount_other": "{{count}} requests pending",
      "leaveRequestsNone": "Nothing pending",
      "expenseClaims": "Expense claims to review",
      "expenseClaimsNone": "Nothing submitted",
      "documentsExpiring": "Documents expiring",
      "documentsExpiringCount_zero": "{{count}} expire within 30 days",
      "documentsExpiringCount_one": "{{count}} expires within 30 days",
      "documentsExpiringCount_other": "{{count}} expire within 30 days",
      "documentsExpiringNone": "Nothing expires within 30 days",
      "headcount": "Headcount",
      "headcountJoined_zero": "{{count}} joined this month",
      "headcountJoined_one": "{{count}} joined this month",
      "headcountJoined_other": "{{count}} joined this month",
      "headcountLeft_zero": "{{count}} left this month",
      "headcountLeft_one": "{{count}} left this month",
      "headcountLeft_other": "{{count}} left this month",
      "openRoles": "Open roles",
      "rolesPipeline_zero": "{{count}} candidates in pipeline",
      "rolesPipeline_one": "{{count}} candidate in pipeline",
      "rolesPipeline_other": "{{count}} candidates in pipeline",
      "rolesPipelineNone": "No candidates in pipeline",
      "payrollRun": "Payroll run",
      "payrollNone": "No run covers the current period"
    },
    "empty": {
      "title": "Nothing to administer yet",
      "body": "None of the company's workspaces are open to your role here. Ask your administrator for access."
    },
    "sections": {
      "attention": "Needs attention",
      "administration": "Administration",
      "openApprovals": "Open the approvals inbox"
    },
    "quickActions": {
      "title": "Quick actions",
      "new": "New",
      "approvals": "Approvals",
      "newInvoice": "New invoice",
      "newSalesOrder": "New sales order",
      "newBill": "New bill",
      "recordExpense": "Record expense",
      "reviewApprovals": "Review approvals ({{count}})"
    }
  },
  "roles": {
    "title": "Roles & permissions",
    "subtitle": "Built-in templates and the custom roles your company has defined.",
    "list": {
      "heading": "Roles",
      "system": "Built-in",
      "custom": "Custom",
      "new": "New role",
      "copy": "Copy",
      "empty": "No custom roles yet",
      "permissionCount_one": "{{count}} grant",
      "permissionCount_other": "{{count}} grants",
      "select": "View {name}"
    },
    "matrix": {
      "column": {
        "object": "module / object",
        "view": "view",
        "create": "create",
        "edit": "edit",
        "delete": "delete",
        "approve": "approve",
        "export": "export",
        "scope": "scope"
      },
      "scope": {
        "own": "own",
        "department": "department",
        "branch": "branch",
        "company": "company",
        "mixed": "Mixed",
        "none": "No grants"
      },
      "granted": "granted",
      "revoked": "revoked",
      "grantAll": "Grant row",
      "revokeAll": "Revoke row",
      "save": "Save changes",
      "saving": "Saving…",
      "saved": "Changes saved",
      "dirty": "Unsaved changes",
      "noChanges": "No changes",
      "readOnly": "Built-in role — read-only",
      "reservedRoleManage": "Reserved for the Owner and Administrator roles",
      "entity": "object",
      "moduleHeading": "module",
      "reservedHeading": "Reserved",
      "summary": "This role can view {{view}} things, change {{change}}, and approve {{approve}}, across the company.",
      "searchPlaceholder": "Search by label or permission key",
      "searchCount": "{{count}} matching rows",
      "clearSearch": "Clear search",
      "reservedPermission": "Manage roles and permissions"
    },
    "detail": {
      "back": "All roles",
      "holders_zero": "No members hold this role",
      "holders_one": "{{count}} member holds this role",
      "holders_other": "{{count}} members hold this role",
      "builtInNotice": "Built-in role — copy it to make a version you can change.",
      "expandAll": "Expand all",
      "collapseAll": "Collapse all",
      "tally": "{{granted}} of {{total}} permissions",
      "noResults": "No permissions match this search.",
      "noValue": "—",
      "notFound": "This role no longer exists."
    },
    "level": {
      "none": "No access",
      "read": "Read",
      "contribute": "Contribute",
      "full": "Full",
      "custom": "Custom",
      "legend": "Access level",
      "help": {
        "none": "No access to this module at all.",
        "read": "Can view records, and change nothing.",
        "contribute": "Can view records, and create and edit them.",
        "full": "Everything, including delete, approve and export."
      }
    },
    "changes": {
      "added_one": "{{count}} permission added",
      "added_other": "{{count}} permissions added",
      "removed_one": "{{count}} permission removed",
      "removed_other": "{{count}} permissions removed",
      "rescoped_one": "{{count}} scope changed",
      "rescoped_other": "{{count}} scopes changed",
      "none": "No changes",
      "discard": "Discard"
    },
    "modules": {
      "heading": "Modules",
      "instruction": "Give each module one access level and one scope. Use Fine-tune only when this role needs an exception.",
      "count": "{{count}} modules",
      "granted": "granted",
      "grantedHelp": "How many of this module's permissions the role holds, out of every one it could.",
      "about": "About {{name}}",
      "fineTune": "Fine-tune",
      "fineTuneFor": "Fine-tune {{module}}",
      "fineTuneHint": "Turn single permissions on or off and set each grant's scope. A change here makes the module read Custom.",
      "branchScopeAvailableFor": "Branch scope is available for: {{permissions}}.",
      "branchScopePermission": "{{action}} {{entity}}",
      "branchScopeListSeparator": ", ",
      "permissionScope": "Scope for {{permission}}",
      "noGrants": "This module grants nothing yet. Choose an access level first.",
      "descriptions": {
        "accounting": "Invoices, bills, payments and the general ledger.",
        "core": "Company settings, branches and shared reference data.",
        "directory": "Customers, suppliers and contacts.",
        "hr": "Employee records, attendance, leave and requests.",
        "identity": "Users, roles and access to the company.",
        "inventory": "Items, warehouses, stock counts and transfers.",
        "payroll": "Pay periods, salaries, payslips and payroll runs.",
        "platform": "Platform operations and support tools.",
        "purchasing": "Purchase orders, supplier bills and returns.",
        "recruitment": "Job openings, candidates and hiring steps.",
        "sales": "Quotes, sales orders, customer invoices and returns.",
        "subscriptions": "Plans, subscriptions and billing for the company.",
        "workflow": "Approval chains and the requests that run through them."
      }
    },
    "scope": {
      "own": "Own",
      "department": "Department",
      "branch": "Branch",
      "company": "Company",
      "mixed": "Mixed",
      "help": {
        "own": "Only the records the person owns or created.",
        "department": "Every record in the person's own department.",
        "branch": "Every employee record in the person's own branch.",
        "company": "Every record in the company."
      }
    },
    "form": {
      "createTitle": "New role",
      "editTitle": "Edit role",
      "copyTitle": "Copy built-in role",
      "nameEn": "Name (English)",
      "nameAr": "Name (Arabic)",
      "descriptionEn": "Description (English)",
      "descriptionAr": "Description (Arabic)",
      "submitCreate": "Create role",
      "submitEdit": "Save",
      "submitCopy": "Create copy",
      "submitting": "Saving…",
      "nameRequired": "Name in English or Arabic is required",
      "createFailed": "Could not create the role",
      "updateFailed": "Could not save the changes"
    },
    "deleteDialog": {
      "title": "Delete this role?",
      "description": "{{name}} and everything it lets members do are removed permanently. This cannot be undone.",
      "confirm": "Delete role"
    },
    "wizard": {
      "details": "Details",
      "permissions": "Permissions",
      "review": "Review",
      "detailsHeading": "Role details",
      "detailsExplanation": "Name the role in both languages. A description is optional.",
      "continue": "Continue",
      "templateHeading": "Start with a template",
      "templateExplanation": "Copy a starting set of grants into this editable role.",
      "blankRole": "Blank role",
      "blankDescription": "Choose grants yourself from the beginning.",
      "grantCount": "{{count}} grants",
      "selected": "Selected",
      "permissionBuilder": {
        "search": "Search permissions",
        "searchPlaceholder": "Search by module or permission",
        "moduleFilter": "Filter by module",
        "allModules": "All modules",
        "summary": "{{selected}} of {{total}} permissions selected",
        "readOnly": "Read-only preview",
        "selectAll": "Select all",
        "viewOnly": "View only",
        "clearModule": "Clear module",
        "scope": "Scope",
        "reservedExplanation": "Reserved for the Owner and Administrator roles; it cannot be selected here.",
        "noResults": "No permissions match this search.",
        "accessSummary": {
          "eyebrow": "Access summary",
          "reviewHeading": "Review access",
          "total": "{{count}} selected grants",
          "noAccess": "No access is selected. This role will not open any protected area.",
          "broadScopeWarning": "Broad scope: this role can act across the company for the grants shown above.",
          "capability": "Can {{actions}} {{entity}} across the {{scope}} scope.",
          "modules": {
            "accounting": "Accounting",
            "core": "Core",
            "directory": "Directory",
            "hr": "Human resources",
            "identity": "Identity",
            "inventory": "Inventory",
            "payroll": "Payroll",
            "platform": "Platform",
            "recruitment": "Recruitment",
            "subscriptions": "Subscriptions",
            "workflow": "Approvals",
            "purchasing": "Purchasing",
            "sales": "Sales"
          },
          "entities": {
            "account": "accounts",
            "accounting_account": "ledger accounts",
            "accounting_account_import": "chart of accounts import",
            "accounting_asset": "fixed assets",
            "accounting_asset_depreciation": "depreciation runs",
            "accounting_asset_disposal": "asset disposals",
            "accounting_bank": "bank accounts",
            "accounting_bank_rule": "bank rules",
            "accounting_bill": "supplier bills",
            "accounting_bill_confirm": "bill confirmation",
            "accounting_bill_debit": "debit notes",
            "accounting_budget": "budgets",
            "accounting_cash_sale": "cash sales",
            "accounting_invoice": "customer invoices",
            "accounting_invoice_confirm": "invoice confirmation",
            "accounting_invoice_credit": "credit notes",
            "accounting_journal": "journal entries",
            "accounting_journal_post": "journal posting",
            "accounting_journal_void": "journal reversal",
            "accounting_money_document": "spend documents",
            "accounting_opening": "opening balances",
            "accounting_opening_post": "opening balance posting",
            "accounting_payment": "payments",
            "accounting_payment_cancel": "payment cancellation",
            "accounting_payment_confirm": "payment confirmation",
            "accounting_period": "fiscal periods",
            "accounting_period_lock": "period locking",
            "accounting_period_unlock": "period unlocking",
            "accounting_post_adjusting_entry": "adjusting entries in a locked period",
            "accounting_reconciliation": "bank reconciliation",
            "accounting_recurring": "recurring templates",
            "accounting_report": "accounting reports",
            "accounting_report_consolidated": "consolidated group reports",
            "accounting_revaluation": "currency revaluation",
            "accounting_settings": "accounting settings",
            "accounting_spend": "expenses and prepayments",
            "accounting_statement_import": "bank statement import",
            "accounting_tax": "tax rates and filings",
            "alert": "alerts",
            "approval": "approvals",
            "asset": "company assets",
            "asset_assignment": "asset assignments",
            "attendance": "attendance records",
            "attendance_correction": "attendance corrections",
            "attendance_import": "attendance import",
            "attendance_kiosk": "attendance kiosks",
            "bill": "bills",
            "cash_custody": "cash custody",
            "collection": "collections and dunning",
            "company": "companies",
            "costing_method": "costing methods",
            "customer": "customers",
            "customer_return": "customer returns",
            "department": "departments",
            "employee": "employees",
            "employee_document": "employee documents",
            "employee_document_restricted": "restricted employee documents",
            "employee_financial": "employee pay details",
            "employee_personal": "employee personal details",
            "expense": "expense claims",
            "expense_category": "expense categories",
            "goods_receipt": "goods receipts",
            "hr_report": "HR reports",
            "hr_workflow": "HR approval paths",
            "hybrid_work": "hybrid work schedules",
            "inventory_report": "inventory reports",
            "invoice": "invoices",
            "leave": "leave requests",
            "leave_balance": "leave balances",
            "leave_eligibility": "leave eligibility",
            "leave_type": "leave types",
            "lot": "lots",
            "notification": "notifications",
            "overtime": "overtime entries",
            "payment": "payments",
            "payroll_component": "salary components",
            "payroll_report": "payroll reports",
            "payroll_report_lines": "payroll component columns",
            "payroll_run": "payroll runs",
            "payroll_run_cancel": "payroll run cancellation",
            "payroll_run_confirm": "payroll run confirmation",
            "payroll_run_pay": "payroll payment",
            "payroll_run_post": "payroll posting",
            "payroll_run_reverse": "payroll run reversal",
            "payslip": "payslips",
            "payslip_release": "payslip release",
            "performance": "performance reviews",
            "performance_cycle": "performance cycles",
            "performance_template": "review templates",
            "permission_request": "permission requests",
            "position": "positions",
            "product": "products",
            "product_attribute": "product attributes",
            "product_category": "product categories",
            "product_variant": "product variants",
            "purchase_bill_allocation": "purchase bill allocation",
            "purchase_order": "purchase orders",
            "recruitment_candidate": "candidates",
            "recruitment_candidate_convert": "candidate conversion to employee",
            "recruitment_candidate_move": "moving candidates between stages",
            "recruitment_opening": "job openings",
            "recruitment_stage": "recruitment stages",
            "role": "roles",
            "sales_order": "sales orders",
            "sales_price_override": "sales price overrides",
            "standard_cost": "standard costs",
            "stock": "stock",
            "stock_adjustment": "stock adjustments",
            "stock_count": "stock counts",
            "stock_location": "stock locations",
            "stock_transfer": "stock transfers",
            "stock_valuation": "stock valuation",
            "supplier": "suppliers",
            "supplier_return": "supplier returns",
            "tag": "tags",
            "unit_of_measure": "units of measure",
            "user": "users",
            "user_access": "activation and reset codes",
            "violation": "conduct violations",
            "warehouse": "warehouses",
            "work_entry": "work entries",
            "work_site": "work sites",
            "workflow": "approval workflows"
          }
        },
        "accessPreview": {
          "eyebrow": "Example access preview",
          "explanation": "These are example areas this role may use; they are not an authorization decision.",
          "empty": "Select a grant to see example areas here.",
          "genericScreen": "Example screens in this module",
          "screens": {
            "identity": "Example screens: Members and Roles",
            "accounting": "Example screens: Invoices, Bills and Payments",
            "directory": "Example screens: Customers, Suppliers and Products",
            "hr": "Example screens: Employees, Attendance and Time off",
            "payroll": "Example screens: Payroll runs and Payslips",
            "recruitment": "Example screens: Candidates and Vacancies"
          }
        },
        "actions": {
          "view": "View",
          "create": "Create",
          "edit": "Edit",
          "delete": "Delete",
          "approve": "Approve",
          "export": "Export",
          "access_all": "Access all warehouses"
        },
        "permissionLabels": {
          "warehouseAccessAll": "Access all warehouses",
          "warehouseAccessAllExplanation": "Allows access to stock and warehouse records across all warehouses."
        }
      }
    },
    "systemRoles": {
      "company_owner": "Owner",
      "company_administrator": "Administrator",
      "accountant": "Accountant",
      "sales_representative": "Sales representative",
      "purchasing_officer": "Purchasing officer",
      "warehouse_keeper": "Warehouse keeper",
      "hr_officer": "HR officer",
      "employee": "Employee",
      "support_agent": "Multaqa support"
    },
    "systemRoleDescriptions": {
      "company_owner": "Can do everything in the company, including managing roles.",
      "company_administrator": "Manages members, their accounts and the company's roles.",
      "accountant": "Does the accounting work for the whole company.",
      "sales_representative": "Works with customers, products and stock needed for sales.",
      "purchasing_officer": "Works with suppliers, products and stock needed for purchasing.",
      "warehouse_keeper": "Manages warehouses, stock locations, lots and stock movements.",
      "hr_officer": "Does HR work for the whole company: employees, their records and their accounts.",
      "employee": "Self-service only: they see their own pay, leave, documents and requests, and no one else's."
    },
    "table": {
      "role": "Role",
      "kind": "Kind",
      "scope": "Default data scope",
      "users": "Users",
      "companyChip": "Company = {{code}}",
      "tally": "{{total}} roles · {{builtIn}} built-in, {{custom}} custom",
      "note": "Built-in roles are templates in code, not rows — they cannot be edited or deleted, only copied. Platform Administrator never appears here: it has no company.",
      "grants": "Grants",
      "open": "Open {{name}}"
    },
    "copies": {
      "title": "Shared with",
      "summary": "{{copies}} copies · {{outOfDate}} out of date",
      "copy": "Copy to…",
      "push": "Push changes",
      "columns": {
        "company": "Company",
        "status": "Status",
        "people": "People",
        "updated": "Updated"
      },
      "status": {
        "in_sync": "In sync",
        "out_of_date": "Out of date",
        "diverged": "Diverged",
        "conflict": "Conflict",
        "no_access": "No access",
        "insufficient_grants": "Cannot push"
      },
      "behindBy": "Missing {{count}} permissions",
      "divergedBy": "Changed locally. Has {{count}} permissions this role does not.",
      "conflictWith": "A different role with the same name already exists here.",
      "noAccess": "You do not manage roles in this company.",
      "insufficient": "Your permissions in this company are narrower than this role.",
      "empty": "This role exists only in this company.",
      "manageExcluded": "The 'manage roles' permission is never copied.",
      "relative": {
        "today": "Today",
        "days": "{{count}} days ago"
      }
    },
    "copy": {
      "title": "Copy {{role}} to other companies",
      "subtitle": "Each company gets its own independent copy. Editing this role later does not change them until you push.",
      "cancel": "Cancel",
      "submit": "Copy to {{count}} companies",
      "submitEmpty": "Select companies",
      "done": "Done",
      "noCompanies": "This group has only one company.",
      "selectAll": "Select all ({{count}})",
      "selected": "{{count}} selected",
      "alreadyHas": "Already has a copy",
      "noAccess": "You do not manage roles in this company.",
      "conflict": "A role called {{name}} already exists here.",
      "mayFail": "Your permissions here are narrower. Some grants may not copy.",
      "copied": "Copied",
      "result": "Copied to {{copied}} of {{total}} companies."
    },
    "push": {
      "title": "Push changes to copies",
      "subtitle": "Push changes for {{role}}",
      "cancel": "Cancel",
      "submit": "Push to {{count}} copies",
      "done": "Done",
      "diffFailed": "We could not work out what would change.",
      "noChanges": "The copies already match this role.",
      "companies": "Companies",
      "willAdd": "This will add ({{count}})",
      "willRemove": "This will remove ({{count}})",
      "willWiden": "This will widen ({{count}})",
      "willNarrow": "This will narrow ({{count}})",
      "showLess": "Show less",
      "showAll": "Show all ({{count}})",
      "inSync": "Already in sync",
      "noAccess": "You do not manage roles in this company.",
      "insufficient": "Your permissions in this company are narrower than this role.",
      "willOverwrite": "Changed locally. Pushing replaces {{count}} local permissions.",
      "peopleAffected": "{{count}} people hold this role here",
      "overwriteWarning": "You are replacing local changes in {{count}} companies. This cannot be undone.",
      "pushed": "Pushed"
    }
  },
  "users": {
    "title": "Members",
    "subtitle": "People with access to this company and the role they hold.",
    "list": {
      "heading": "Members",
      "summary_one": "{{count}} member",
      "summary_other": "{{count}} members",
      "empty": "No members yet",
      "emptyDescription": "Invite your first team member to get started.",
      "invite": "Invite member",
      "columns": {
        "member": "Member",
        "role": "Role",
        "branch": "Branch",
        "status": "Status",
        "actions": "Actions",
        "lastSignIn": "Last sign-in"
      },
      "remove": "Remove",
      "edit": "Edit role",
      "removeDialog": {
        "title": "Remove this member?",
        "description": "They will lose access to this company. They will need a new invitation to come back."
      },
      "removeAction": "Remove member",
      "noResultsTitle": "No members match your search",
      "noResultsBody": "Try a different search term, or clear the search to see every member.",
      "never": "Never",
      "actions": "Member actions",
      "suspend": "Suspend",
      "reactivate": "Reactivate",
      "passwordReset": "Send reset email",
      "resetCode": "Hand over a reset code",
      "filters": {
        "role": "Role",
        "allRoles": "All roles",
        "status": "Status",
        "allStatuses": "All statuses"
      },
      "confirm": {
        "title": {
          "suspend": "Suspend this member?",
          "reactivate": "Reactivate this member?",
          "reset": "Send a password-reset email?",
          "resetCode": "Hand over a reset code?"
        },
        "body": {
          "suspend": "{{name}} ({{email}}) will lose access to this company until reactivated.",
          "reactivate": "{{name}} ({{email}}) will regain access to this company.",
          "reset": "A password-reset link will be sent to {{name}} at {{email}}.",
          "resetCode": "Issue a one-time reset code for {{name}}?"
        },
        "action": {
          "suspend": "Suspend member",
          "reactivate": "Reactivate member",
          "reset": "Send email",
          "resetCode": "Issue code"
        }
      },
      "success": {
        "suspend": "Member suspended",
        "reactivate": "Member reactivated",
        "passwordReset": "Password-reset email sent to {{email}}",
        "remove": "Member removed"
      }
    },
    "invitations": {
      "title": "Pending invitations",
      "count_one": "{{count}} invitation",
      "count_other": "{{count}} invitations",
      "columns": {
        "email": "Email or phone",
        "role": "Role",
        "sent": "Sent",
        "employee": "Employee",
        "expires": "Expires",
        "status": "Status",
        "actions": "Actions"
      },
      "status": {
        "pending": "Pending",
        "expired": "Expired",
        "no_code": "No code yet"
      },
      "rowActions": "Actions for {{email}}",
      "select": "Select",
      "selectRow": "Select invitation for {{name}}",
      "printSelected": "Print access cards ({{count}})",
      "cardsTitle": "Access cards ({{count}})",
      "print": "Print",
      "closeCards": "Close",
      "issueCode": "Issue code",
      "reprintCode": "Reprint code",
      "reprintTitle": "Reprint this access card?",
      "reprintWarning": "The previous code will stop working.",
      "reprintSelected": "Reprint access cards",
      "reprintSelectedTitle": "Reprint selected access cards?",
      "reprintSelectedWarning": "{{count}} printed cards will stop working.",
      "card": {
        "companyEn": "Company",
        "companyAr": "الشركة",
        "qrLabel": "Activation QR code",
        "expires": "Expires",
        "instructionsEn": "Install the Multaqa app, tap Activate, then scan this code.",
        "instructionsAr": "ثبّت تطبيق ملتقى، واضغط تفعيل، ثم امسح هذا الرمز."
      },
      "resend": "Resend",
      "resendSuccess": "Invitation sent again to {{email}}",
      "resendError": "Could not resend the invitation.",
      "rateLimited": "Too many requests. Try again in a minute.",
      "cancel": "Cancel invitation",
      "dismiss": "Back",
      "cancelTitle": "Cancel this invitation?",
      "cancelDescription": "The invitation for {{email}} will be cancelled. The link in the email will stop working.",
      "cancelPhoneDescription": "The invitation for {{phone}} will be cancelled and its activation code will stop working.",
      "cancelSuccess": "Invitation cancelled",
      "cancelError": "Could not cancel the invitation."
    },
    "loginPhone": {
      "title": "Change login phone",
      "label": "Login phone",
      "change": "Change login phone",
      "remove": "Remove",
      "useHrPhone": "Use HR phone",
      "issueCode": "Issue phone-change code",
      "issueCodeBody": "Enter the new number. The code works only for that number, once, for 24 hours.",
      "issueCodeAction": "Issue code"
    },
    "phoneChangeCode": {
      "title": "Phone-change code",
      "forNumber": "For {{phone}}",
      "warning": "Give this code only to the member in person. It works only for this number, once, for 24 hours."
    },
    "resetCode": {
      "title": "Reset code",
      "warning": "Give this code only to the member in person. It works once, for 24 hours."
    },
    "status": {
      "active": "Active",
      "suspended": "Suspended",
      "removed": "Removed"
    },
    "errors": {
      "lastOwner": "A company must always have at least one active owner. Promote someone else to owner first, then remove this member.",
      "removedInvite": "This user is no longer a member of the company. Send them a new invitation to bring them back.",
      "generic": "Could not update the member"
    },
    "invite": {
      "title": "Invite a member",
      "subtitle": "They will receive an email with a link to set up their account.",
      "phoneSubtitle": "Create an account invitation and hand the activation code to the employee.",
      "method": "Invitation method",
      "methods": {
        "email": "Email",
        "phone": "Phone"
      },
      "email": "Email",
      "name": "Full name",
      "phone": "Phone",
      "role": "Role",
      "roleSystem": "Built-in roles",
      "roleCustom": "Custom roles",
      "rolePlaceholder": "Choose a role",
      "noAssignableRoles": "You cannot assign any role. Ask an owner or an administrator.",
      "employee": "Employee record (optional)",
      "employeePlaceholder": "Search employees…",
      "employeeHint": "Link this account to an employee record so they see their own attendance, leave and payslips.",
      "submit": "Send invitation",
      "submitting": "Sending…",
      "success": "Invitation sent.",
      "errors": {
        "email": "Enter a valid email address",
        "name": "Enter the employee’s full name",
        "phone": "Enter a phone number",
        "role": "Choose a role for the invitation",
        "generic": "Could not send the invitation"
      }
    },
    "form": {
      "editTitle": "Edit member",
      "editSubtitle": "Change the role or the status, one at a time.",
      "roleLabel": "Role",
      "customRoleFallback": "Custom role",
      "roleNotAssignable": "You cannot change this member's role, because it has permissions you do not have.",
      "branchLabel": "Branch",
      "branchHelp": "Branch-scoped permissions of this user apply to this branch.",
      "noBranch": "No branch",
      "statusLabel": "Status",
      "noRole": "No role",
      "submit": "Save change",
      "submitting": "Saving…",
      "errors": {
        "oneChange": "Change the role or the status, one at a time.",
        "noChange": "No change to save"
      }
    }
  },
  "groups": {
    "title": "Groups",
    "subtitle": "Company groups on the platform, their plans and their state.",
    "tally": "{{count}} groups",
    "columns": {
      "group": "Group",
      "status": "Status",
      "plan": "Plan",
      "actions": "Actions"
    },
    "status": {
      "active": "Active",
      "suspended": "Suspended",
      "pending_purge": "Pending purge",
      "purged": "Purged"
    },
    "filter": {
      "status": "Status",
      "all": "All statuses"
    },
    "tabs": {
      "overview": "Overview",
      "entitlements": "Entitlements",
      "users": "Users",
      "invitations": "Invitations",
      "settings": "Settings",
      "defaults": "Defaults"
    },
    "noPlan": "No plan",
    "open": "Open",
    "suspend": "Suspend",
    "reactivate": "Reactivate",
    "copyId": "Copy group id",
    "changePlan": {
      "none": "No plan (modules only)"
    },
    "suspendDialog": {
      "title": "Suspend {{name}}?",
      "description": "{{name}} loses access immediately. It can be reactivated at any point before the purge runs.",
      "confirm": "Suspend group",
      "success": "{{name}} suspended."
    },
    "reactivateDialog": {
      "title": "Reactivate {{name}}?",
      "description": "{{name}} regains access immediately.",
      "confirm": "Reactivate",
      "success": "{{name}} reactivated."
    },
    "atLimit": "At the plan limit. Change the plan to add more.",
    "slots": {
      "unlimited": "Unlimited"
    },
    "defaults": {
      "empty": {
        "title": "No defaults configured",
        "body": "Group defaults will appear here once they are loaded."
      },
      "note": "Defaults apply to new companies in this group. Existing company settings stay unchanged.",
      "errors": {
        "generic": "Could not save group defaults."
      },
      "settings": {
        "title": "Group defaults",
        "cancel": "Cancel",
        "save": "Save changes",
        "saved": "Defaults saved",
        "reset": "Reset to platform defaults",
        "resetSaved": "Defaults reset",
        "edit": "Edit defaults",
        "systemDefault": "Platform default: {{value}}",
        "fields": {
          "paymentTerms": "Default payment terms",
          "allowNegativeStock": "Allow negative stock",
          "expiryConvention": "When is an item considered expired?",
          "expiryWarningDays": "Expiry warning days",
          "allocationStrategy": "Allocation strategy",
          "overReceiptPolicy": "Over-receipt policy",
          "permissionMonthlyMinutes": "Monthly permission minutes",
          "brandingAccentColor": "Branding accent colour"
        },
        "values": {
          "on": "On the expiry date",
          "after": "After the expiry date",
          "fefo": "First-expiry, first-out (FEFO)",
          "fifo": "First-in, first-out (FIFO)",
          "block": "Block",
          "allow": "Allow",
          "none": "Not set",
          "enabled": "Enabled",
          "disabled": "Disabled"
        }
      },
      "templates": {
        "add": "Add",
        "edit": "Edit",
        "deleteAction": "Delete",
        "loadSystem": "Load system defaults",
        "loaded": "System defaults loaded.",
        "saved": "Template saved.",
        "deleted": "Template deleted.",
        "columns": {
          "nameEn": "Name (English)",
          "nameAr": "Name (Arabic)",
          "code": "Code",
          "actions": "Actions"
        },
        "form": {
          "createTitle": "Add template",
          "editTitle": "Edit template",
          "nameEn": "Name (English)",
          "nameAr": "Name (Arabic)",
          "code": "Code",
          "nameRequired": "Enter the name in both languages",
          "codeRequired": "Enter a code",
          "cancel": "Cancel",
          "saveCreate": "Add template",
          "saveEdit": "Save changes"
        },
        "delete": {
          "title": "Delete this template?",
          "body": "Template {{code}} will be deleted. This cannot be undone.",
          "cancel": "Cancel",
          "confirm": "Delete"
        },
        "departments": {
          "title": "Department templates",
          "description": "Template departments are copied to new companies in this group.",
          "emptyTitle": "No department templates yet",
          "emptyBody": "Add a department template or load the system defaults."
        },
        "positions": {
          "title": "Position templates",
          "description": "Template positions are copied to new companies in this group.",
          "emptyTitle": "No position templates yet",
          "emptyBody": "Add a position template or load the system defaults."
        }
      }
    },
    "addCompany": {
      "action": "Add company",
      "title": "Add a company to {{group}}",
      "subtitle": "{{used}} of {{max}} slots used.",
      "legalNameEn": "Legal name (English)",
      "legalNameAr": "Legal name (Arabic)",
      "tradingNameEn": "Trading name (English)",
      "tradingNameAr": "Trading name (Arabic)",
      "code": "Code",
      "currency": "Base currency",
      "currencyPlaceholder": "Choose a currency",
      "country": "Country",
      "countryPlaceholder": "Choose a country",
      "noUsers": "This customer has no users yet.",
      "owners": "Owners",
      "ownerElsewhere": "Owner of {{n}} companies",
      "noOwners": "This company will have no owner until you add one.",
      "submitFailed": "Could not add the company.",
      "otherErrors": "Other issues with this submission:",
      "submit": "Add company",
      "timezone": "Time zone"
    },
    "empty": {
      "title": "No groups yet",
      "body": "Groups appear here once a customer organisation is registered.",
      "filteredTitle": "No groups match this filter",
      "filteredBody": "Try a different status.",
      "searchBody": "Try a different name, or clear the filters."
    },
    "search": {
      "label": "Search groups",
      "placeholder": "Search by name…"
    },
    "detail": {
      "subtitle": "One group: companies, plan, and support access.",
      "notFound": "That group does not exist or is not visible to you.",
      "companies": {
        "title_one": "{{count}} company",
        "title_other": "{{count}} companies",
        "emptyTitle": "No companies yet",
        "emptyBody": "Add the group's first company from the groups list."
      },
      "plan": {
        "title": "Plan and entitlements",
        "slotsLine_one": "{{count}} of {{limit}} company slots used",
        "slotsLine_other": "{{count}} of {{limit}} company slots used"
      },
      "modules": {
        "title": "Modules",
        "empty": "This group's plan grants no modules.",
        "clear": "Clear the override for {{module}}",
        "clearDialog": {
          "title": "Clear the override for {{module}}?",
          "description": "{{module}} reverts to whatever the plan grants. This can disable a module a customer uses today.",
          "confirm": "Clear override",
          "success": "Override cleared for {{module}}."
        }
      },
      "features": {
        "title": "Features",
        "empty": "This group's plan declares no features.",
        "clear": "Clear the override for {{feature}}",
        "clearDialog": {
          "title": "Clear the override for {{feature}}?",
          "description": "{{feature}} reverts to whatever the plan grants.",
          "confirm": "Clear override",
          "success": "Override cleared for {{feature}}."
        }
      },
      "limits": {
        "title": "Limits",
        "empty": "This group's plan declares no limits.",
        "columns": {
          "key": "Key",
          "value": "Value",
          "source": "Source"
        }
      },
      "entitlementsSource": {
        "plan": "From plan",
        "override": "Override"
      },
      "overview": {
        "groupId": "Group ID",
        "slug": "Slug",
        "created": "Created",
        "plan": "Plan",
        "modulesOnly": "Modules only",
        "currency": "Presentation currency",
        "modules": "Enabled modules",
        "noModules": "No modules enabled."
      },
      "purge": {
        "action": "Schedule purge",
        "dialog": {
          "title": "Schedule purge for {{name}}?",
          "description": "This schedules the group for deletion once the purge grace period ends. Type the group's slug to confirm.",
          "slugLabel": "Group slug",
          "slugPlaceholder": "Type {{slug}} to confirm",
          "confirm": "Schedule purge",
          "success": "Purge scheduled for {{name}}."
        }
      },
      "sessions": {
        "title": "Support sessions into this group",
        "emptyTitle": "No support sessions here yet",
        "emptyBody": "Sessions opened for this group — active and past — will appear here."
      },
      "erasure": {
        "title": "Erasure",
        "description": "A dry run counts what erasure would delete for this purged group: rows per table, stored files and users. It deletes nothing.",
        "dryRun": "Run dry run",
        "dryRunAgain": "Run dry run again",
        "dryRunDone": "Dry run finished. Nothing was deleted.",
        "plannedAt": "Last dry run: {{date}}",
        "noPlan": "No dry run yet. Run one to see what erasure would delete.",
        "noBlockers": "No blockers",
        "blockersTitle": "Erasure is blocked",
        "blockers": {
          "cross_group_link": "A row of another group points at this group's data:",
          "demo_group": "This is the demo group; the demo reset owns its data:",
          "open_support_session": "Support sessions into this group are still open:"
        },
        "auditTitle": "Audit trail",
        "auditBody": "{{kept}} security rows are kept with their old and new values cleared; {{deleted}} financial rows are deleted. This follows our retention rule and waits for legal counsel.",
        "taxTitle": "Tax records",
        "taxBody": "The customer keeps their own books for the tax authority. Make sure they exported their data before erasure. This waits for legal counsel.",
        "totals": {
          "rows": "Rows",
          "tables": "Tables",
          "files": "Files",
          "users": "Users"
        },
        "columns": {
          "table": "Table",
          "rows": "Rows",
          "folder": "Folder",
          "files": "Files",
          "size": "Size"
        },
        "bytes_one": "{{value}} byte",
        "bytes_other": "{{value}} bytes"
      }
    },
    "settings": {
      "title": "Group settings",
      "view": {
        "edit": "Edit settings"
      },
      "fields": {
        "presentationCurrency": "Presentation currency",
        "currencyPlaceholder": "Choose a currency",
        "intercompanyMirroring": "Intercompany mirroring",
        "retentionDays": "Retention days",
        "purgeGraceDays": "Purge grace days"
      },
      "platformDefault": "Platform default",
      "values": {
        "enabled": "Enabled",
        "disabled": "Disabled"
      },
      "form": {
        "cancel": "Cancel",
        "save": "Save changes",
        "saved": "Group settings saved"
      }
    },
    "users": {
      "title": "Users in this group",
      "emptyTitle": "No users yet",
      "emptyBody": "This group has no users.",
      "columns": {
        "name": "Name",
        "email": "Email or phone",
        "companies": "Companies",
        "owner": "Company owner",
        "twoFactor": "Two-factor",
        "actions": "Actions"
      },
      "owner": "Owner",
      "twoFactor": {
        "on": "On",
        "reset": "Reset two-factor authentication",
        "resetFor": "Reset two-factor authentication for {{name}}",
        "hint": "Open a support session for this group to reset a user's two-factor authentication.",
        "dialogTitle": "Reset two-factor authentication?",
        "dialogBody": "{{name}} is signed out on every device and must set up two-factor authentication again at the next sign-in. They get an email about it, and the reset goes in the audit trail.",
        "reason": "Reason",
        "reasonPlaceholder": "For example: lost phone, ticket 77",
        "confirm": "Reset two-factor",
        "noSession": "Your support session for this group has ended. Open a new one, then try again.",
        "failed": "The reset did not go through. Try again.",
        "done": "Two-factor authentication is reset for {{name}}."
      }
    },
    "invitations": {
      "title": "Pending invitations",
      "emptyTitle": "No pending invitations",
      "emptyBody": "This group has no pending invitations.",
      "columns": {
        "email": "Email or phone",
        "company": "Company",
        "role": "Role",
        "status": "Status",
        "expires": "Expires",
        "actions": "Actions"
      },
      "resend": "Resend",
      "revoke": "Revoke",
      "status": {
        "pending": "Pending",
        "expired": "Expired",
        "accepted": "Accepted",
        "revoked": "Revoked"
      },
      "revokeDialog": {
        "title": "Revoke the invitation for {{email}}?",
        "description": "{{email}} will no longer be able to accept this invitation. It can be re-sent later as a new invitation.",
        "confirm": "Revoke invitation"
      },
      "resendSuccess": "Invitation resent to {{email}}.",
      "revokeSuccess": "Invitation for {{email}} revoked."
    }
  },
  "state": {
    "loading": "Loading…",
    "empty": "Nothing to show",
    "error": "Something went wrong",
    "inactive": "Inactive",
    "saved": "Saved",
    "saving": "Saving…"
  },
  "status": {
    "active": "Active",
    "inactive": "Inactive"
  },
  "none": "None",
  "onboarding": {
    "title": "Onboard a customer",
    "subtitle": "Create a group, choose its modules, add its companies, and invite the first owner.",
    "steps": {
      "customer": "Customer",
      "modules": "Modules",
      "defaults": "Defaults",
      "companies": "Companies",
      "owner": "First owner",
      "completed": "✓ "
    },
    "defaults": {
      "subtitle": "Set defaults for companies in this group. You can change them later.",
      "optional": "All fields on this step are optional.",
      "skip": "Skip defaults",
      "sections": {
        "settings": "Settings",
        "departments": "Department templates",
        "positions": "Position templates"
      },
      "placeholders": {
        "choose": "Choose an option"
      },
      "fields": {
        "paymentTermsDays": "Default payment terms (days)",
        "expiryWarningDays": "Expiry warning days",
        "permissionMonthlyMinutes": "Monthly permission minutes",
        "expiryConvention": "When is an item considered expired?",
        "allocationStrategy": "Allocation strategy",
        "overReceiptPolicy": "Over-receipt policy",
        "brandingAccentColor": "Branding accent colour",
        "allowNegativeStock": "Allow negative stock"
      },
      "helpButton": "More information about {{field}}",
      "help": {
        "paymentTermsDays": "Sets the default number of days allowed to pay invoices.",
        "expiryWarningDays": "Sets how many days before expiry the system warns users.",
        "permissionMonthlyMinutes": "Sets the monthly allowance for permission requests, in minutes.",
        "expiryConvention": "Choose whether an item is considered expired on the date shown or the following day.",
        "allocationStrategy": "Chooses how stock is allocated: earliest expiry first or oldest receipt first.",
        "overReceiptPolicy": "Controls whether receiving more than ordered is blocked or allowed.",
        "brandingAccentColor": "Sets the accent colour used for this company's branding.",
        "allowNegativeStock": "Controls whether stock can fall below zero."
      },
      "options": {
        "on": "On the expiry date",
        "after": "After the expiry date",
        "fefo": "First-expiry, first-out (FEFO)",
        "fifo": "First-in, first-out (FIFO)",
        "block": "Block",
        "allow": "Allow"
      },
      "templates": {
        "nameEn": "Name (English)",
        "nameAr": "Name (Arabic)",
        "code": "Code",
        "departments": {
          "hint": "Used when setting up a new company.",
          "add": "Add department",
          "empty": "No department templates added.",
          "remove": "Remove department template"
        },
        "positions": {
          "hint": "Used when setting up a new company.",
          "add": "Add position",
          "empty": "No position templates added.",
          "remove": "Remove position template"
        }
      }
    },
    "slots": "Slots",
    "optional": "Optional",
    "nameHint": "Enter at least one name, in English or Arabic.",
    "submit": "Create customer",
    "submitting": "Creating…",
    "submitFailed": "Could not create the customer.",
    "submitErrorTitle": "We could not create this customer",
    "submitValidationFailed": "Some details need your attention before we can create the customer.",
    "submitValidationHint": "Correct the errors shown on this step and try again.",
    "submitUnexpectedFailed": "We could not set up this customer. Your entries are still here; try again.",
    "submitReference": "Reference: {{reference}}",
    "leaveWarning": "Your entries are not saved until you create the customer.",
    "validation": {
      "name": "Enter the customer name in at least one language.",
      "plan": "Choose a plan.",
      "companyName": "Enter the legal name in at least one language.",
      "code": "Enter a company code.",
      "country": "Choose a country.",
      "currency": "Choose a base currency.",
      "duplicateCode": "Each company code must be unique.",
      "ownerName": "Enter the first owner's name.",
      "ownerEmail": "Enter a valid email address for the first owner."
    },
    "customer": {
      "nameEn": "Customer name (English)",
      "nameAr": "Customer name (Arabic)",
      "slug": "URL: {{slug}}",
      "plan": "Plan",
      "planLoadFailed": "Could not load the plans.",
      "planPlaceholder": "Choose a plan",
      "planLimits": "{{companies}} companies, {{users}} users",
      "slotsHint": "This plan allows {{max}} companies. You can add the rest later.",
      "noPlan": "No plan (modules only)",
      "noPlanHint": "Modules and limits are set directly on this customer.",
      "limitsCompanies": "Companies limit",
      "limitsUsers": "Users limit",
      "limitsStorage": "Storage (MB)",
      "advanced": "Advanced settings",
      "purgeGraceDays": "Purge grace days",
      "defaultGrace": "Use the platform default"
    },
    "modules": {
      "intro": "Choose the modules this customer's plan includes. You can change this later.",
      "loadFailed": "Could not load the module catalogue.",
      "none": "No module switches were returned.",
      "fromPlan": "Included in the plan",
      "requiredBy": "Required by Inventory",
      "desc": {
        "hr": "Manage people, attendance and time off.",
        "accounting": "Manage accounts, transactions and financial reporting.",
        "inventory": "Manage products, stock and warehouse movements."
      }
    },
    "companies": {
      "slots": "{{used}} of {{max}} slots used",
      "holding": "Holding company",
      "company": "Company {{count}}",
      "remove": "Remove company",
      "legalNameEn": "Legal name (English)",
      "legalNameAr": "Legal name (Arabic)",
      "tradingName": "Trading name",
      "tradingNameEn": "Trading name (English)",
      "tradingNameAr": "Trading name (Arabic)",
      "code": "Code",
      "currency": "Base currency",
      "currencyPlaceholder": "Choose a currency",
      "atLimit": "This plan allows {{max}} companies. Choose a larger plan to add more.",
      "add": "Add company",
      "country": "Country",
      "countryPlaceholder": "Choose a country",
      "timezone": "Time zone"
    },
    "countries": {
      "EG": "Egypt",
      "SA": "Saudi Arabia",
      "AE": "United Arab Emirates",
      "KW": "Kuwait",
      "BH": "Bahrain",
      "OM": "Oman",
      "QA": "Qatar",
      "JO": "Jordan"
    },
    "owner": {
      "name": "Owner name",
      "email": "Owner email",
      "roleNote": "Will be the company owner of all {{count}} companies.",
      "emailNote": "We will email {{email}} an invitation to set their own password. You will not see or set it."
    },
    "done": {
      "title": "{{name}} is ready",
      "invited": "An invitation has been emailed to {{email}}. It expires {{date}}.",
      "groupCreated": "Group {{name}} was created, along with its companies and the owner invitation.",
      "slots": "{{used}} of {{max}} slots used",
      "next": {
        "1": "The owner accepts the invitation and sets a password.",
        "2": "The owner signs in at the company app.",
        "3": "The owner adds their own users and roles."
      },
      "backToGroups": "Back to groups",
      "allGroups": "All groups",
      "another": "Onboard another",
      "companies": "{{count}} companies"
    }
  },
  "mcpConnect": {
    "trail": "Connected apps",
    "title": "Allow access",
    "asks": "{{client}} asks to work in Multaqa as you.",
    "returnsTo": "The access goes to:",
    "canList": "It can list the customer groups and their companies.",
    "needsSession": "To read or change a customer's data, it must open a support session, and you type a fresh authenticator code each time.",
    "confirmWrites": "Every change it proposes waits for your confirmation.",
    "revokeLater": "You can remove this access later from your settings.",
    "allow": "Allow",
    "deny": "Deny",
    "approveFailed": "The access could not be granted. Start again from your app.",
    "invalidTitle": "This connection request is not valid",
    "invalidBody": "The app is not registered with Multaqa, or its return address does not match. Start again from your app."
  },
  "supportSessions": {
    "title": "Support access",
    "subtitle": "Time-limited access into a customer group. Every session is recorded and visible to the company.",
    "groupLabel": "Group",
    "groupPlaceholder": "Choose a group",
    "overview": {
      "title": "Across all groups",
      "meta": "Open sessions, plus those that expired in the last 24 hours",
      "columns": {
        "group": "Group"
      },
      "emptyTitle": "No support sessions are open anywhere",
      "emptyBody": "Nothing is open or recently expired across any group. Grant one below, per group.",
      "errorTitle": "Could not load the overview",
      "error": "Could not read the support sessions."
    },
    "grant": {
      "heading": "Grant support access",
      "reason": "Reason",
      "reasonPlaceholder": "What does this session need to do?",
      "minutes": "Minutes",
      "minutesPlaceholder": "60",
      "minutesHint": "Optional. Defaults to 60 minutes, maximum 240.",
      "submit": "Grant access",
      "code": "Authenticator code",
      "codePlaceholder": "123456",
      "codeHint": "The current 6-digit code from your authenticator app."
    },
    "errors": {
      "reasonRequired": "A reason is required",
      "minutesInvalid": "Enter a whole number between 1 and 240",
      "codeRequired": "Enter the current authenticator code",
      "handoffFailed": "Could not open the support link. Check that the session is still active."
    },
    "sessions": {
      "heading": "Sessions",
      "columns": {
        "granted": "Granted",
        "expires": "Expires",
        "reason": "Reason",
        "status": "Status",
        "actions": "Actions",
        "agent": "Support agent"
      },
      "active": "Active",
      "revoked": "Revoked",
      "expired": "Expired",
      "revoke": "Revoke",
      "emptyTitle": "No sessions yet",
      "emptyBody": "Sessions opened into this group appear here.",
      "errorTitle": "Could not load sessions",
      "errorBody": "The sessions granted into this group could not be loaded.",
      "viewActions": "View actions",
      "end": "End session",
      "openAsSupport": "Open as support",
      "viaAssistant": "via Multaqa Assistant",
      "assistantHelp": "Multaqa Assistant uses AI. It reads your data and proposes changes, and the support agent approves each change before it runs."
    },
    "companyView": {
      "title": "Support sessions",
      "subtitle": "Platform support sessions opened into your group. Every session is recorded and visible here.",
      "errorTitle": "We could not load the support sessions.",
      "emptyTitle": "No support sessions",
      "emptyBody": "Sessions opened by platform support into this group appear here."
    },
    "banner": {
      "title": "Support session",
      "body": "{{name}} from Multaqa support is working in your company until {{time}}. Every action is recorded.",
      "end": "End now"
    },
    "enter": {
      "headline": "Support access",
      "eyebrow": "Multaqa support",
      "title": "Opening the support session",
      "lede": "One moment. You are signing in as your support user.",
      "failedTitle": "This support link does not work",
      "failedBody": "The link is used, expired, or its session has ended. Open a new one from the admin app."
    },
    "ended": {
      "headline": "Support access",
      "title": "The support session has ended",
      "lede": "You are signed out of this company. Its owners can see everything the session did in their audit trail.",
      "close": "Close this tab"
    }
  },
  "errors": {
    "fileAction": "The file could not be produced. Try again, or contact support if it keeps failing."
  },
  "error": {
    "generic": {
      "title": "Something went wrong",
      "body": "This is our fault, not yours. Quote the reference below and we can find exactly what happened."
    },
    "asyncTitle": "This section could not be loaded",
    "asyncBody": "We could not load {{title}}. Please try again.",
    "network": {
      "title": "Connection problem",
      "body": "We could not connect. Check your connection and try again."
    },
    "unauthorized": {
      "title": "Your session has expired",
      "body": "Sign in again to continue. Nothing you saved has been lost."
    },
    "suspended": {
      "title": "Your account is suspended",
      "body": "This organisation's access has been suspended. Contact your administrator."
    },
    "forbidden": {
      "title": "You do not have access to this",
      "body": "Your role does not include this screen. If you think it should, ask your administrator."
    },
    "openSupport": "Open a support session",
    "notFound": {
      "title": "Not found",
      "body": "This record does not exist, or it belongs to another company.",
      "goToDashboard": "Go to the dashboard",
      "pageTitle": "This page does not exist",
      "pageBody": "Check the address, or go back to the dashboard."
    },
    "conflict": {
      "title": "That could not be saved"
    },
    "validation": "Please check the highlighted fields.",
    "boundary": {
      "notFound": "We could not load {{path}}. The page may have been removed, or it may belong to another company.",
      "forbidden": "Access to {{path}} was denied. Your role does not include this page."
    },
    "rateLimited": {
      "title": "Too many attempts",
      "body": "Wait a minute and try again."
    },
    "reference": "Reference",
    "referenceHint": "Quote this if you contact support.",
    "details": "Technical details",
    "moduleNotEnabled": "This module is not enabled."
  },
  "feature": {
    "names": {
      "remove_branding": "Remove Multaqa branding"
    }
  },
  "module": {
    "names": {
      "hr": "Human resources",
      "accounting": "Accounting",
      "inventory": "Inventory",
      "purchasing": "Purchasing",
      "sales": "Sales",
      "subscriptions": "Subscriptions"
    },
    "notEnabled": {
      "title": "Not included in your plan",
      "body": "The {{module}} module is not part of your current plan. Contact your administrator to have it enabled."
    }
  },
  "directory": {
    "entityKinds": {
      "customer": "Customer",
      "supplier": "Supplier",
      "employee": "Employee"
    }
  },
  "accounting": {
    "payee": {
      "placeholder": "Select a payee",
      "search": "Search customers, suppliers or employees…",
      "empty": "No payees match"
    }
  },
  "recordHistory": {
    "trigger": "History",
    "title": "Record history",
    "description": "Changes made to this record.",
    "empty": "No changes recorded yet.",
    "noValue": "No value",
    "view": "View",
    "openInAudit": "Open in audit trail",
    "event": "{{action}}"
  },
  "platformConsole": {
    "title": "Platform console",
    "subtitle": "Our side of the product.",
    "signedInAs": "Signed in as {{name}}. Operators have no company context.",
    "customers": {
      "title": "Customers",
      "meta": "groups and companies",
      "body": "Manage customer groups, plans and company capacity from the platform console.",
      "open": "Open groups"
    },
    "operations": {
      "title": "Operations",
      "meta": "support, audit, health",
      "body": "Open a recorded support session or review the platform audit trail.",
      "support": "Support sessions",
      "audit": "Platform audit",
      "auditNeedsSession": "Needs an active support session — open one from Support sessions."
    },
    "stats": {
      "groups": "Groups",
      "groupsNote": "{{active}} active, {{suspended}} suspended",
      "companies": "Companies",
      "companiesNote": "Across all groups",
      "atLimit": "At plan limit",
      "atLimitNote": "of {{count}} with a known limit",
      "openSessions": "Open support sessions",
      "openSessionsNote": "Granted and not yet expired or revoked"
    },
    "activity": {
      "title": "Recent activity",
      "meta": "Feedback and support",
      "feedbackTitle": "Recent feedback",
      "feedbackError": "Could not load recent feedback.",
      "feedbackEmpty": "No feedback yet.",
      "supportTitle": "Open support",
      "supportCount_one": "{{count}} open support session",
      "supportCount_other": "{{count}} open support sessions",
      "supportError": "Could not load open support sessions.",
      "supportEmpty": "No open support sessions.",
      "viewAll": "View all"
    },
    "quickActions": {
      "title": "Quick actions",
      "provisionTenant": "Onboard a customer",
      "managePlans": "Manage plans",
      "grantSupport": "Grant support access"
    },
    "recentGroups": {
      "title": "Recent groups",
      "meta": "Latest customer groups",
      "error": "Could not load recent groups.",
      "emptyTitle": "No groups yet",
      "provision": "Onboard a customer",
      "viewAll": "View all groups",
      "columns": {
        "name": "Group",
        "plan": "Plan",
        "companies": "Companies",
        "status": "Status",
        "created": "Created"
      }
    }
  },
  "plans": {
    "title": "Plans & entitlements",
    "subtitle": "The plan catalogue, and what each group effectively holds.",
    "catalogue": {
      "heading": "Plan catalogue",
      "newPlan": "New plan",
      "columns": {
        "name": "Plan",
        "status": "Status",
        "entitlements": "Entitlements",
        "actions": "Actions"
      },
      "active": "Active",
      "inactive": "Inactive",
      "entitlementCount_one": "{{count}} entitlement",
      "entitlementCount_other": "{{count}} entitlements",
      "edit": "Edit plan",
      "deactivate": "Deactivate",
      "delete": "Delete",
      "emptyTitle": "No plans yet",
      "emptyBody": "Create the first plan to start assigning customers."
    },
    "form": {
      "createTitle": "New plan",
      "editTitle": "Edit plan",
      "nameEn": "Name (English)",
      "nameAr": "Name (Arabic)",
      "active": "Active",
      "identity": "Plan details",
      "entitlements": {
        "title": "Entitlements",
        "description": "Set the limits and modules included in this plan.",
        "loadFailed": "Could not load the entitlement catalogue.",
        "empty": "No entitlements are available.",
        "valueLabel": "Value for {{key}}",
        "clearValue": "Clear value for {{key}}",
        "kind": {
          "switch": "Switch",
          "limit": "Limit"
        },
        "columns": {
          "key": "Key",
          "kind": "Type",
          "value": "Value",
          "actions": "Actions"
        }
      },
      "impactConfirm": {
        "title_one": "{{count}} group uses this plan",
        "title_other": "{{count}} groups use this plan",
        "overridesUnaffected": "Group-specific overrides will not be changed.",
        "save": "Save plan"
      },
      "submitCreate": "Create plan",
      "submitEdit": "Save changes",
      "nameRequired": "Enter the name in at least one language",
      "createFailed": "Could not create the plan",
      "updateFailed": "Could not save the plan"
    },
    "deleteDialog": {
      "title": "Delete this plan?",
      "description": "{{name}} is removed from the catalogue. Groups already on it keep their current access.",
      "confirm": "Delete plan",
      "inUse": "This plan is assigned to one or more groups and cannot be deleted. Deactivate it instead."
    },
    "groupContext": {
      "heading": "Group context",
      "groupLabel": "Group",
      "groupPlaceholder": "Choose a group",
      "noGroup": "Choose a group to see its effective entitlements.",
      "currentPlan": "Current plan",
      "changePlan": "Change plan",
      "columns": {
        "key": "Entitlement",
        "module": "Module",
        "planValue": "Plan value",
        "override": "Override",
        "effective": "Effective"
      },
      "noValue": "—",
      "changePlanDialog": {
        "title": "Change plan for {{name}}",
        "planLabel": "New plan",
        "planPlaceholder": "Choose a plan",
        "confirm": "Change plan",
        "warnTitle": "This change disables a module",
        "warnBody_one": "{{module}} will be disabled. All its data is retained and stays available if the module is re-enabled later.",
        "warnBody_other": "{{modules}} will be disabled. All their data is retained and stays available if the modules are re-enabled later."
      }
    }
  },
  "platformSettings": {
    "title": "Platform settings",
    "subtitle": "Runtime defaults for retention, supported locales and uploads.",
    "view": {
      "edit": "Edit settings"
    },
    "fields": {
      "retention_days": "Retention days",
      "retention_days_hint": "How long a suspended group stays in retention before the purge is scheduled.",
      "purge_grace_days": "Purge grace days",
      "purge_grace_days_hint": "The notice period between a pending purge and the purge itself.",
      "selectable_locales": "Selectable locales",
      "selectable_locales_hint": "Comma-separated locale codes the company apps may offer.",
      "max_upload_mb": "Max upload size (MB)",
      "max_upload_mb_hint": "The largest single upload the platform accepts."
    },
    "form": {
      "save": "Save changes",
      "cancel": "Cancel"
    },
    "errors": {
      "required": "This value is required",
      "numeric": "Enter a whole number",
      "locales": "Enter comma-separated locale codes"
    },
    "general": {
      "title": "General settings"
    },
    "mobileVersions": {
      "title": "Mobile app versions",
      "description": "The employee app checks these when it opens and when it comes back to the screen. Leave a field empty to turn its check off.",
      "edit": "Edit versions",
      "notSet": "Not set",
      "minimumHint": "Builds below this version must update before they open.",
      "latestHint": "Builds below this version see an update prompt they can close.",
      "fields": {
        "mobile_min_version_android": "Android minimum version",
        "mobile_latest_version_android": "Android latest version",
        "mobile_min_version_ios": "iOS minimum version",
        "mobile_latest_version_ios": "iOS latest version"
      }
    },
    "socialInsuranceLimits": {
      "title": "Social insurance limits",
      "description": "The legal minimum and maximum insurable wage for each year. Payroll uses them for every company.",
      "columns": {
        "year": "Year",
        "minimum": "Minimum",
        "maximum": "Maximum",
        "actions": "Actions"
      },
      "add": "Add year",
      "edit": "Edit limits for {{year}}",
      "remove": "Remove limits for {{year}}",
      "empty": "No limits yet. Add the current year before the first payroll run of the year.",
      "dialog": {
        "addTitle": "Add yearly limits",
        "editTitle": "Edit {{year}} limits",
        "description": "Enter the legal insurable wage limits in EGP for this year.",
        "year": "Year",
        "minimum": "Minimum (EGP)",
        "maximum": "Maximum (EGP)",
        "removeTitle": "Remove yearly limits",
        "removeDescription": "Remove the {{year}} minimum and maximum insurable wages? Payroll will not have a legal limit for this year.",
        "removeConfirm": "Remove limits"
      },
      "errors": {
        "yearRequired": "Enter a year.",
        "yearRange": "Enter a year from 2019 to 2100.",
        "yearDuplicate": "Limits for this year already exist.",
        "amountRequired": "Enter an amount.",
        "amountDecimal": "Enter a positive amount with no more than two decimal places.",
        "minimumPositive": "The minimum must be greater than zero.",
        "maximumGreater": "The maximum must be greater than the minimum."
      }
    },
    "salaryTaxTables": {
      "title": "Salary tax tables",
      "description": "The Egyptian salary income tax rules for each effective date: exemptions, bands and high-income rules. Payroll uses the table in force on each pay date, for every company.",
      "columns": {
        "effectiveFrom": "Effective from",
        "personalExemption": "Personal exemption",
        "disabilityExemption": "Disability exemption",
        "actions": "Actions"
      },
      "add": "Add table",
      "edit": "Edit",
      "editLabel": "Edit the table from {{date}}",
      "dialog": {
        "addTitle": "Add salary tax table",
        "editTitle": "Edit salary tax table",
        "description": "All amounts are annual, in EGP. Rates are percentages. A new table starts as a copy of the newest one.",
        "effectiveFrom": "Effective from",
        "effectiveFromHint": "Payroll uses this table for pay dates on or after this date.",
        "personalExemption": "Personal exemption (EGP)",
        "disabilityExemption": "Disability exemption (EGP)",
        "roundingUnit": "Rounding unit (EGP)",
        "martyrsFundRate": "Martyrs' Fund rate (%)",
        "bands": "Tax bands",
        "bandsHint": "Annual taxable income after the personal exemption. The last band has no upper limit.",
        "upTo": "Up to (EGP)",
        "rate": "Rate (%)",
        "noUpperLimit": "No upper limit",
        "bandUpTo": "Band {{number}} upper limit (EGP)",
        "bandRate": "Band {{number}} rate (%)",
        "removeBand": "Remove band {{number}}",
        "addBand": "Add band",
        "rules": "High-income rules",
        "rulesHint": "Above an annual income, the lower bands no longer apply: income up to the flat-rate ceiling is taxed at one rate.",
        "ruleTitle": "Rule {{number}}",
        "over": "Annual income over (EGP)",
        "flatUpTo": "Flat-rate ceiling (EGP)",
        "removeRule": "Remove rule {{number}}",
        "addRule": "Add rule"
      },
      "errors": {
        "required": "Enter a value.",
        "rate": "Enter a percentage from 0 to 100 with no more than two decimal places."
      }
    }
  },
  "companies": {
    "title": "Companies",
    "subtitle": "Your group's entities and how they nest. Branches sit under the entity that owns them.",
    "emptyBody": "Companies are added by Multaqa support. Contact us to add one.",
    "status": {
      "label": "Status",
      "active": "Active",
      "suspended": "Suspended",
      "deactivated": "Deactivated"
    },
    "list": {
      "empty": "No entities yet",
      "columns": {
        "entity": "Entity",
        "code": "Code",
        "currency": "Base currency",
        "status": "Status",
        "actions": "Actions"
      },
      "edit": "Edit entity",
      "editActiveOnly": "Only the company you are signed in to can be edited from here.",
      "rootsNote": "Top-level entities",
      "summary": "{{total}} entities in the group",
      "noResultsTitle": "No entities match your search",
      "noResultsBody": "Try a different search term, or clear the search to see every entity."
    },
    "edit": {
      "title": "Edit {{name}}"
    },
    "form": {
      "legalNameEn": "Legal name (English)",
      "legalNameAr": "Legal name (Arabic)",
      "tradingNameEn": "Trading name (English)",
      "tradingNameAr": "Trading name (Arabic)",
      "code": "Code",
      "codeHint": "A short identifier, unique in the group.",
      "country": "Country",
      "countryHint": "ISO 3166-1 alpha-2, e.g. EG or SA.",
      "baseCurrency": "Base currency",
      "baseCurrencyReadOnly": "Base currency is fixed after creation.",
      "registrationNumber": "Registration number",
      "taxIdentifier": "Tax identifier",
      "defaultLocale": "Default locale",
      "localeEnglish": "English",
      "localeArabic": "Arabic",
      "createdAt": "Created",
      "fiscalYearStart": "Fiscal year starts in",
      "fiscalSetup": "Fiscal year",
      "fiscalSetupHint": "The first fiscal year is created with these settings. Its periods cannot change after it is created.",
      "periods": "Periods",
      "monthly": "Monthly",
      "monthlyHint": "12 periods, one for each month.",
      "quarterly": "Quarterly",
      "quarterlyHint": "4 periods of three months. The first quarter starts in the first month of your fiscal year.",
      "parent": "Parent entity",
      "parentNone": "Top-level entity",
      "validationTitle": "Please check the highlighted fields.",
      "parentLoadFailed": "Could not load parent entities.",
      "retryParents": "Try again",
      "nameRequired": "Enter the legal name in at least one language",
      "codeRequired": "Enter a code",
      "countryRequired": "Enter the country code",
      "currencyRequired": "Choose a base currency",
      "localeRequired": "Choose a default locale",
      "monthRequired": "Choose the fiscal year start month",
      "submitCreate": "Add entity",
      "submitEdit": "Save changes",
      "submitting": "Saving…",
      "createFailed": "Could not add the entity",
      "updateFailed": "Could not save the entity",
      "parentFailed": "Could not move the entity",
      "cycleRefused": "That parent would create a cycle — an entity cannot be nested beneath its own branch.",
      "groupRefused": "You cannot choose this entity as the parent. Choose a different entity.",
      "month": {
        "1": "January",
        "2": "February",
        "3": "March",
        "4": "April",
        "5": "May",
        "6": "June",
        "7": "July",
        "8": "August",
        "9": "September",
        "10": "October",
        "11": "November",
        "12": "December"
      }
    },
    "tabs": {
      "overview": "Overview",
      "settings": "Settings",
      "departments": "Departments",
      "positions": "Positions",
      "sequences": "Sequences",
      "imports": "Data import"
    },
    "common": {
      "empty": "No value",
      "loading": "Loading…"
    },
    "notFound": {
      "title": "Company not found",
      "body": "This company does not exist in the selected group or is no longer available.",
      "back": "Back to group"
    },
    "detail": {
      "deactivate": "Deactivate",
      "reactivate": "Reactivate",
      "deactivateDialog": {
        "title": "Deactivate {{name}}?",
        "description": "{{name}} will no longer be usable until it is reactivated. Its history and settings are kept.",
        "confirm": "Deactivate"
      },
      "deactivated": "{{name}} was deactivated.",
      "reactivated": "{{name}} was reactivated.",
      "loadFailed": {
        "title": "Could not load this company",
        "body": "Try again, or go back to the group."
      }
    },
    "settings": {
      "groups": {
        "purchasing": "Purchasing",
        "purchasingDescription": "Defaults and rules for purchasing and receiving.",
        "approvals": "Approvals",
        "approvalsDescription": "Set the threshold that sends transactions for review.",
        "hr": "Human resources",
        "hrDescription": "Monthly permission allowance used by HR workflows.",
        "branding": "Branding",
        "brandingDescription": "Read-only branding settings for this company.",
        "warehousing": "Warehousing",
        "warehousingDescription": "Default warehouses used for returns and fulfilment.",
        "regional": "Time zone",
        "regionalDescription": "Local time for attendance and the mobile app."
      },
      "fields": {
        "paymentTerms": "Default payment terms",
        "approvalThreshold": "Approval threshold",
        "approvalCurrency": "Approval threshold currency",
        "overReceipt": "Over-receipt policy",
        "negativeStock": "Allow negative stock",
        "expiryConvention": "When is an item considered expired?",
        "expiryWarningDays": "Expiry warning days",
        "allocationStrategy": "Allocation strategy",
        "permissionMonthlyMinutes": "Monthly permission minutes",
        "accentColor": "Branding accent colour",
        "logo": "Logo",
        "returnsWarehouse": "Returns warehouse",
        "fulfilmentWarehouse": "Fulfilment warehouse",
        "timezone": "Time zone"
      },
      "values": {
        "overReceipt": {
          "block": "Block",
          "allow": "Allow"
        },
        "expiry": {
          "on": "On the expiry date",
          "after": "After the expiry date"
        },
        "allocation": {
          "fefo": "First-expiry, first-out (FEFO)",
          "fifo": "First-in, first-out (FIFO)"
        },
        "enabled": "Enabled",
        "disabled": "Disabled",
        "days": "days"
      },
      "form": {
        "save": "Save changes",
        "edit": "Edit",
        "wholeNumber": "Enter a whole number",
        "saveFailed": "Could not save the company settings",
        "currencyRequired": "Choose a currency for the approval threshold"
      }
    },
    "departments": {
      "title": "Departments",
      "subtitle": "Your company's department tree. Departments nest beneath a parent.",
      "add": "Add department",
      "empty": "No departments yet",
      "emptyDescription": "Add the first department to start structuring the company.",
      "nameEn": "Name (English)",
      "nameAr": "Name (Arabic)",
      "code": "Code",
      "parent": "Parent department",
      "status": "Status",
      "actions": "Actions",
      "active": "Active",
      "inactive": "Inactive",
      "rowActions": "Actions for {{code}}",
      "edit": "Edit department",
      "nameRequired": "Enter the name in at least one language",
      "codeRequired": "Enter a code",
      "saveFailed": "Could not save the department",
      "editTitle": "Edit department",
      "createTitle": "Add department",
      "parentNone": "Top-level department",
      "submitEdit": "Save changes",
      "submitCreate": "Add department"
    },
    "positions": {
      "title": "Positions",
      "subtitle": "The job titles employees can hold in this company.",
      "add": "Add position",
      "empty": "No positions yet",
      "emptyDescription": "Add the first position to start assigning people.",
      "nameEn": "Name (English)",
      "nameAr": "Name (Arabic)",
      "code": "Code",
      "status": "Status",
      "actions": "Actions",
      "active": "Active",
      "inactive": "Inactive",
      "rowActions": "Actions for {{code}}",
      "edit": "Edit position",
      "nameRequired": "Enter the name in at least one language",
      "codeRequired": "Enter a code",
      "saveFailed": "Could not save the position",
      "editTitle": "Edit position",
      "createTitle": "Add position",
      "submitEdit": "Save changes",
      "submitCreate": "Add position"
    },
    "imports": {
      "title": "Data import",
      "subtitle": "Load this company's branches, departments, employees and more from one workbook.",
      "template": "Download template",
      "templateTitle": "Download a template",
      "templateDescription": "Choose the sheets this company needs. Each sheet lists its columns, and columns marked * are required for new records.",
      "templateDownload": "Download",
      "templateNone": "Choose at least one sheet.",
      "templateFailed": "Could not download the template",
      "upload": "Upload workbook",
      "uploadHint": "An .xlsx file of up to 10 MB, made from the template.",
      "uploadFailed": "Could not upload the workbook",
      "validating": "Checking the workbook. This takes a few seconds.",
      "applying": "Applying the import. This takes a few seconds.",
      "ready": "The preview is ready. Nothing is saved until you apply it.",
      "readyWithWarnings": "The preview is ready, with warnings to review below. Nothing is saved until you apply it.",
      "invalid": "The workbook has problems. Fix them in the file and upload it again.",
      "stale": "The company's data changed after this preview. Upload the file again to get a fresh preview.",
      "applied": "Imported. The audit trail records each change.",
      "failed": "The import stopped and nothing was saved. Fix the problems and upload the file again.",
      "cancelled": "This import was cancelled. Nothing was saved.",
      "expired": "This import expired after 7 days without being applied. Nothing was saved.",
      "apply": "Apply import",
      "cancel": "Cancel import",
      "applyTitle": "Apply this import?",
      "applyBody": "This will change {{company}}: {{created}} new, {{updated}} updated.",
      "applyNote": "The audit trail records you as the person who made these changes.",
      "applyConfirm": "Apply",
      "keepPreview": "Not now",
      "applyFailed": "Could not apply the import",
      "cancelFailed": "Could not cancel the import",
      "summary": "Summary",
      "sheet": "Sheet",
      "created": "New",
      "updated": "Updated",
      "unchanged": "Unchanged",
      "errors": "Problems",
      "problems": "Problems to fix",
      "problemsMore": "Showing the first {{shown}} of {{total}} problems.",
      "row": "Row",
      "column": "Column",
      "problem": "Problem",
      "wholeRow": "Whole row",
      "warnings": "Warnings to review",
      "warning": "Warning",
      "warningsHint": "These rows still import. Review each one in the file, or on the record after you apply.",
      "changes": "What changes",
      "changesHint": "Field names only. Values stay in the file.",
      "totals": "Totals",
      "history": "Import history",
      "historyEmpty": "No imports yet",
      "historyEmptyDescription": "Download the template, fill it in, and upload it here.",
      "file": "File",
      "uploadedBy": "Uploaded by",
      "uploadedAt": "Uploaded",
      "statusLabel": "Status",
      "result": "Result",
      "resultCounts": "{{created}} new, {{updated}} updated",
      "open": "Open",
      "close": "Close preview",
      "importAction": "Import",
      "sheetsHeading": "Choose sheets",
      "sheetsHint": "Pick the sheets you want. The template holds only the sheets you pick.",
      "uploadHeading": "Upload the filled workbook",
      "noSheets": "You cannot import any sheet yet. Ask an administrator for the permission a sheet needs.",
      "door": {
        "admin": "Platform team",
        "company": "Company user"
      },
      "status": {
        "validating": "Checking",
        "ready": "Ready to apply",
        "invalid": "Has problems",
        "applying": "Applying",
        "applied": "Applied",
        "failed": "Failed",
        "stale": "Out of date",
        "cancelled": "Cancelled",
        "expired": "Expired"
      }
    },
    "sequences": {
      "title": "Document sequences",
      "subtitle": "How each document type is numbered in this company.",
      "empty": "No sequences yet",
      "emptyDescription": "Add a sequence for each document type that needs a number.",
      "type": "Document type",
      "prefix": "Prefix",
      "next": "Next number",
      "padding": "Padding",
      "preview": "Preview next",
      "actions": "Actions",
      "edit": "Edit sequence",
      "previewFailed": "Could not preview the next number",
      "editTitle": "Edit sequence",
      "prefixRequired": "Enter a prefix",
      "paddingInvalid": "Enter a whole number from 1 to 20",
      "saveFailed": "Could not save the sequence",
      "submitEdit": "Save changes",
      "resetLabel": "Reset frequency",
      "reset": {
        "never": "Never",
        "yearly": "Yearly",
        "monthly": "Monthly"
      }
    }
  },
  "companySettings": {
    "title": "Company settings",
    "subtitle": "Defaults and policy for this company.",
    "groups": {
      "identity": "Identity",
      "identityDescription": "Company identity and branding.",
      "financial": "Financial",
      "financialDescription": "Defaults used when recording transactions.",
      "approvals": "Approvals",
      "approvalsDescription": "Rules that decide when a transaction needs review.",
      "stock": "Stock",
      "stockDescription": "How receipts, shortages and stock adjustments are handled.",
      "costing": "Inventory costing",
      "costingDescription": "How stock is valued and when costing starts.",
      "regional": "Time zone",
      "regionalDescription": "Local time for attendance and the mobile app."
    },
    "view": {
      "edit": "Edit settings",
      "editSection": "Edit {{section}}"
    },
    "fields": {
      "paymentTerms": "Default payment terms",
      "paymentTermsDays": "days",
      "termDays_one": "{{count}} day",
      "termDays_other": "{{count}} days",
      "overReceipt": "Over-receipt policy",
      "overReceiptHint": "Block refuses a receipt for more than the order; Allow accepts it and records the excess.",
      "negativeStock": "Allow negative stock",
      "negativeStockHint": "Stock may go below zero when goods ship before the receipt is booked.",
      "adjustmentReasons": "Adjustment reasons",
      "adjustmentReasonsHint": "The stock adjustment form offers only these reasons. Add at least one before anyone records an adjustment.",
      "adjustmentReasonsEmpty": "No adjustment reasons yet",
      "adjustmentReasonPlaceholder": "For example: Cycle count",
      "addAdjustmentReason": "Add reason",
      "removeAdjustmentReason": "Remove {{reason}}",
      "reasonSeparator": ", ",
      "expiryConvention": "When is an item considered expired?",
      "expiryWarningDays": "Expiry warning days",
      "allocationStrategy": "Allocation strategy",
      "permissionMonthlyMinutes": "Monthly permission minutes",
      "returnsWarehouse": "Returns warehouse",
      "fulfilmentWarehouse": "Fulfilment warehouse",
      "accentColor": "Branding accent colour",
      "logoPath": "Branding logo path",
      "logo": "Logo",
      "approvalThreshold": "Approval threshold",
      "approvalThresholdHint": "Transactions at or above this amount require approval.",
      "approvalCurrency": "Approval threshold currency",
      "defaultCostingMethod": "Default costing method",
      "defaultCostingMethodHint": "Used by every product category that does not set its own method.",
      "costingCutoverDate": "Costing start date",
      "costingCutoverHint": "Stock is valued by its costing method from this date. It can be set only once.",
      "costingCutoverNotSet": "Not set",
      "timezone": "Time zone"
    },
    "logo": {
      "upload": "Upload logo",
      "replace": "Replace logo",
      "remove": "Remove logo",
      "none": "No logo",
      "hint": "PNG, JPG or WebP, up to 1 MB. It prints at the top of every PDF.",
      "previewAlt": "Company logo",
      "uploaded": "Logo saved.",
      "removed": "Logo removed."
    },
    "overReceipt": {
      "block": "Block",
      "allow": "Allow"
    },
    "values": {
      "expiryOn": "On the expiry date",
      "expiryAfter": "After the expiry date",
      "fefo": "First-expiry, first-out (FEFO)",
      "fifo": "First-in, first-out (FIFO)"
    },
    "accent": {
      "placeholder": "#0F766E",
      "pick": "Pick a colour",
      "hint": "A hex colour such as #0F766E. Leave it empty to use the standard dark colour.",
      "invalid": "Enter a colour as # and six letters or digits, for example #0F766E.",
      "preview": "Preview on documents",
      "previewCompany": "Your company",
      "previewTitle": "Invoice"
    },
    "form": {
      "save": "Save changes",
      "saving": "Saving…",
      "saved": "Settings saved",
      "cancel": "Cancel",
      "amountInvalid": "Enter an amount such as 50000.00",
      "currencyRequired": "Choose a currency for the threshold",
      "costingMethodChange": "Stock in categories that use the company default will move to the new method when you save.",
      "costingForbidden": "You do not have permission to change the costing method."
    },
    "errors": {
      "generic": "Could not save the settings"
    },
    "documents": {
      "title": "Documents",
      "description": "What prints on purchase orders, sales orders and quotations. Your company name, address, tax number and logo come from the company profile.",
      "options": {
        "show_sku": "Item code",
        "show_discount": "Discount",
        "show_tax": "Tax",
        "show_notes": "Notes",
        "show_reference": "The other party's reference",
        "show_signatures": "Signature lines",
        "show_serials": "Serial numbers (sales orders)"
      },
      "kinds": {
        "purchase_order": "Purchase order",
        "sales_order": "Sales order",
        "quotation": "Quotation"
      },
      "previewOf": "Preview",
      "previewTitle": "Document preview",
      "previewLoading": "Preparing the preview…",
      "previewFailed": "The preview could not be prepared.",
      "save": "Save",
      "reset": "Undo changes",
      "saved": "Document options saved.",
      "saveFailed": "The document options could not be saved."
    }
  },
  "departments": {
    "title": "Departments",
    "subtitle": "Your company's department tree. Departments nest beneath a parent.",
    "list": {
      "add": "Add department",
      "empty": "No departments yet",
      "emptyDescription": "Add the first department to start structuring the company.",
      "columns": {
        "department": "Department",
        "code": "Code",
        "actions": "Actions",
        "parent": "Parent",
        "status": "Status"
      },
      "edit": "Edit department",
      "rootsNote": "Top-level departments",
      "summary_one": "{{total}} department",
      "summary_other": "{{total}} departments",
      "status": {
        "active": "Active",
        "hidden": "Hidden"
      },
      "showHidden": "Show hidden",
      "rowActions": "Actions for {{code}}",
      "actions": {
        "hide": "Hide",
        "unhide": "Unhide",
        "delete": "Delete",
        "hideInstead": "Hide instead"
      },
      "deleteTitle": "Delete department?",
      "deleteDescription": "Delete {{name}}? This cannot be undone.",
      "actionFailed": "The change could not be saved.",
      "noResultsTitle": "No departments match your search",
      "noResultsBody": "Try a different search term, or clear the search to see every department."
    },
    "form": {
      "createTitle": "Add department",
      "editTitle": "Edit department",
      "nameEn": "Name (English)",
      "nameAr": "Name (Arabic)",
      "code": "Code",
      "codeHint": "A short identifier, unique in the company.",
      "costCenter": "Cost center",
      "costCenterPlaceholder": "Select a cost center",
      "costCenterAutomatic": "Leave this empty to create a matching cost center automatically.",
      "parent": "Parent department",
      "parentNone": "Top-level department",
      "active": "Active",
      "nameRequired": "Enter the name in at least one language",
      "codeRequired": "Enter a code",
      "cycleRefused": "That parent would create a cycle — a department cannot sit beneath its own subtree.",
      "submitCreate": "Add department",
      "submitEdit": "Save changes",
      "submitting": "Saving…",
      "createFailed": "Could not add the department",
      "updateFailed": "Could not save the department"
    }
  },
  "branches": {
    "title": "Branches",
    "subtitle": "The places this company trades from. A branch is a location, not a function.",
    "list": {
      "add": "Add branch",
      "empty": "No branches yet",
      "emptyDescription": "A branch is a place this company trades from — a shop, a depot, a regional office. A department is a function and repeats in every branch; a branch is one location.",
      "columns": {
        "branch": "Branch",
        "employeeCount": "Employees",
        "code": "Code",
        "status": "Status",
        "actions": "Actions"
      },
      "edit": "Edit branch",
      "summary_one": "{{total}} branch",
      "summary_other": "{{total}} branches",
      "status": {
        "active": "Active",
        "inactive": "Inactive"
      },
      "rowActions": "Actions for {{code}}",
      "actions": {
        "archive": "Archive",
        "restore": "Restore"
      },
      "editRecord": "Edit branch {{name}}",
      "archiveRecord": "Archive branch {{name}}",
      "restoreRecord": "Restore branch {{name}}",
      "actionFailed": "The branch {{name}} could not be updated.",
      "errorTitle": "The branches could not be loaded",
      "errorDescription": "The list did not arrive. Check your connection and try again.",
      "retry": "Try again",
      "noResultsTitle": "No branches match your search",
      "noResultsBody": "Try a different term, or clear the search to see every branch."
    },
    "form": {
      "createTitle": "Add branch",
      "editTitle": "Edit branch",
      "nameEn": "Name (English)",
      "nameAr": "Name (Arabic)",
      "code": "Code",
      "codeHint": "A short identifier, unique in the company.",
      "active": "Active",
      "nameRequired": "Enter the name in at least one language",
      "codeRequired": "Enter a code",
      "codeTaken": "Another branch in this company already uses the code {{code}}. Codes must be unique inside one company.",
      "submitCreate": "Add branch",
      "submitEdit": "Save changes",
      "submitting": "Saving…",
      "createFailed": "Could not add the branch",
      "updateFailed": "Could not save the branch"
    }
  },
  "positions": {
    "title": "Positions",
    "subtitle": "The job titles employees can hold in this company.",
    "list": {
      "add": "Add position",
      "empty": "No positions yet",
      "emptyDescription": "Add the first position to start assigning people.",
      "columns": {
        "position": "Position",
        "code": "Code",
        "actions": "Actions",
        "status": "Status"
      },
      "edit": "Edit position",
      "summary_one": "{{total}} position",
      "summary_other": "{{total}} positions",
      "status": {
        "active": "Active",
        "hidden": "Hidden"
      },
      "showHidden": "Show hidden",
      "rowActions": "Actions for {{code}}",
      "actions": {
        "hide": "Hide",
        "unhide": "Unhide",
        "delete": "Delete",
        "hideInstead": "Hide instead"
      },
      "deleteTitle": "Delete position?",
      "deleteDescription": "Delete {{name}}? This cannot be undone.",
      "actionFailed": "The change could not be saved.",
      "noResultsTitle": "No positions match your search",
      "noResultsBody": "Try a different search term, or clear the search to see every position."
    },
    "form": {
      "createTitle": "Add position",
      "editTitle": "Edit position",
      "nameEn": "Name (English)",
      "nameAr": "Name (Arabic)",
      "code": "Code",
      "codeHint": "A short identifier, unique in the company.",
      "active": "Active",
      "nameRequired": "Enter the name in at least one language",
      "codeRequired": "Enter a code",
      "submitCreate": "Add position",
      "submitEdit": "Save changes",
      "submitting": "Saving…",
      "createFailed": "Could not add the position",
      "updateFailed": "Could not save the position"
    }
  },
  "documentSequences": {
    "title": "Numbering",
    "subtitle": "Choose how new records are numbered, for example EMP-0001.",
    "list": {
      "add": "Add numbering",
      "empty": "No numbering yet",
      "emptyDescription": "Add numbering for each record that needs a number.",
      "columns": {
        "type": "Record",
        "prefix": "Prefix",
        "next": "Next number",
        "padding": "Digits",
        "reset": "Starts again",
        "actions": "Actions"
      },
      "edit": "Edit numbering",
      "summary_one": "{{total}} numbering rule",
      "summary_other": "{{total}} numbering rules",
      "noResultsTitle": "No numbering rules match your filters",
      "module": "Module",
      "moduleAll": "All modules",
      "noResultsBody": "Try another module or search term, or clear the filters to see every numbering rule."
    },
    "modules": {
      "hr": "HR and payroll",
      "sales": "Sales",
      "purchasing": "Purchasing",
      "accounting": "Accounting",
      "inventory": "Inventory",
      "directory": "Customers and products",
      "other": "Other"
    },
    "types": {
      "asset": "Asset",
      "bank_deposit": "Bank deposit",
      "bank_transfer": "Bank transfer",
      "bill": "Supplier bill",
      "card_credit": "Card credit",
      "cash_sale": "Cash sale",
      "cheque": "Cheque",
      "credit_note": "Credit note",
      "customer": "Customer",
      "debit_note": "Debit note",
      "employee": "Employee",
      "expense": "Expense",
      "fixed_asset": "Fixed asset",
      "invoice": "Invoice",
      "journal_entry": "Journal entry",
      "payment": "Payment",
      "payroll_run": "Payroll run",
      "stock_transfer": "Stock transfer",
      "sales_order": "Sales order",
      "customer_return": "Customer return",
      "purchase_order": "Purchase order",
      "goods_receipt": "Goods receipt",
      "supplier_return": "Supplier return",
      "landed_cost": "Landed cost",
      "product": "Product",
      "unknown": "Other record"
    },
    "form": {
      "createTitle": "Add numbering",
      "editTitle": "Edit numbering",
      "documentType": "Record",
      "documentTypeHint": "The record being numbered, for example an invoice.",
      "prefix": "Prefix",
      "nextNumber": "Next number",
      "nextNumberHint": "Current value: {{current}}. A number can only move forward. Moving it forward leaves a gap in the sequence.",
      "largeJumpConfirmation": "This jump is more than 100. Type CONFIRM to continue.",
      "largeJumpText": "CONFIRM",
      "padding": "Digits",
      "resetFrequency": "Starts again",
      "resetNever": "Never",
      "resetYearly": "Yearly",
      "resetMonthly": "Monthly",
      "typeRequired": "Enter a record",
      "prefixRequired": "Enter a prefix",
      "submitCreate": "Add numbering",
      "submitEdit": "Save changes",
      "submitting": "Saving…",
      "createFailed": "Could not add numbering",
      "updateFailed": "Could not save numbering"
    },
    "preview": {
      "action": "Preview next",
      "next": "Next number",
      "hint": "Previewing never consumes the number.",
      "failed": "Could not preview the next number"
    }
  },
  "companyAudit": {
    "title": "Audit trail",
    "subtitle": "Every change to sensitive records: who, what and when.",
    "description": "Every change to sensitive records: who, what and when.",
    "summary": "{{count}} {{changeUnit}} by {{people}} {{peopleUnit}} on {{records}} {{recordUnit}}",
    "changes": {
      "one": "change",
      "other": "changes"
    },
    "people": {
      "one": "person",
      "other": "people"
    },
    "records": {
      "one": "record",
      "other": "records"
    },
    "loadMore": "Load more",
    "loadError": "Please try again.",
    "export": {
      "action": "Export CSV",
      "done": "Audit trail exported.",
      "capped": "The export is limited to 10,000 records.",
      "error": "The audit trail could not be exported."
    },
    "filters": {
      "person": "Person",
      "allPeople": "All people",
      "module": "Module",
      "allModules": "All modules",
      "recordType": "Record type",
      "allRecordTypes": "All record types",
      "record": "Record",
      "selectedRecord": "Selected record",
      "allActions": "All actions",
      "date": "Date",
      "search": "Search",
      "searchPlaceholder": "Search names and records…",
      "action": "Action",
      "from": "From",
      "to": "To",
      "actions": {
        "created": "Created",
        "changed": "Changed",
        "deleted": "Deleted",
        "other": "Other"
      },
      "presets": {
        "today": "Today",
        "7days": "Last 7 days",
        "30days": "Last 30 days",
        "month": "This month"
      },
      "supportSession": "Support session",
      "supportSessionValue": "Selected session"
    },
    "timeline": {
      "today": "Today",
      "yesterday": "Yesterday",
      "created": "created",
      "changed": "changed",
      "deleted": "deleted",
      "system": "System",
      "hidden": "Changed",
      "maskedTooltip": "You do not have access to this value",
      "showLess": "Show less",
      "moreChanges": "+{{count}} more changes",
      "requestChanges_one": "{{count}} event",
      "requestChanges_other": "{{count}} events"
    },
    "detail": {
      "changes": "Changes",
      "old": "Before",
      "new": "After",
      "actor": "Person",
      "date": "Date and time",
      "reference": "Request reference",
      "copyReference": "Copy request reference",
      "copied": "Copied",
      "ip": "IP address",
      "device": "Device",
      "unknown": "Unknown",
      "actingFor": "Acting for",
      "openRecord": "Open record",
      "showHistory": "Show this record's history",
      "related": "Related activity"
    },
    "noValue": "—",
    "errorTitle": "We could not load the audit trail.",
    "emptyTitle": "No audit events yet",
    "emptyBody": "Administration events appear here once they are recorded.",
    "noResultsTitle": "No audit events match these filters",
    "noResultsBody": "Try a different search term, or clear the filters to see every event."
  },
  "unsaved": {
    "title": "Leave without saving?",
    "body": "The changes on this screen have not been saved yet. Leaving now loses them.",
    "stay": "Stay",
    "leave": "Leave"
  },
  "announcements": {
    "title": "Announcements",
    "description": "Send a message to customers, or test that email and push notifications arrive.",
    "compose": {
      "title": "New message",
      "audience": "Send to",
      "audiences": {
        "all": "Everyone",
        "company": "One company",
        "user": "One person"
      },
      "everyoneHelp": "Every active user in every active company.",
      "company": "Company",
      "companyPlaceholder": "Choose a company",
      "companySearch": "Search by name or code",
      "companyMembers_one": "{{count}} active member",
      "companyMembers_other": "{{count}} active members",
      "person": "Person",
      "personPlaceholder": "Choose a person",
      "personSearch": "Search by name or email",
      "personSearchHint": "Type at least two letters.",
      "phones_zero": "No phone registered",
      "phones_one": "1 phone registered",
      "phones_other": "{{count}} phones registered",
      "noResults": "No matches.",
      "channels": "Channels",
      "channelNames": {
        "in_app": "In-app",
        "email": "Email",
        "push": "Push"
      },
      "channelsRequired": "Choose at least one channel.",
      "mode": "Delivery",
      "modes": {
        "queued": "Through the queue",
        "direct": "Direct"
      },
      "queuedHelp": "The same path as real notifications. Use it to test the worker.",
      "directHelp": "Skips the queue and shows the provider reply at once. Use it to test Firebase and the mail server.",
      "directOnlyOnePerson": "Direct delivery is available only for one person.",
      "english": "English",
      "arabic": "Arabic",
      "optional": "optional",
      "messageTitle": "Title",
      "messageBody": "Message",
      "arabicFallback": "Arabic readers see the English text when this is empty.",
      "send": "Send",
      "sendTest": "Send test",
      "required": "Required.",
      "confirmTitle": "Send to everyone?",
      "confirmBody": "Every active user in every active company gets this message. You cannot edit or recall it.",
      "cancel": "Cancel",
      "sent": "Message sent."
    },
    "history": {
      "title": "Sent",
      "empty": "Nothing sent yet",
      "emptyDescription": "Messages you send appear here with their delivery counts.",
      "sentAt": "Sent",
      "message": "Message",
      "audience": "Audience",
      "recipients": "People",
      "email": "Email",
      "push": "Push",
      "notSent": "Not sent",
      "counts": "{{sent}} sent · {{failed}} failed · {{queued}} queued",
      "view": "Deliveries",
      "loadError": "The sent messages could not be loaded."
    },
    "report": {
      "title": "Deliveries",
      "close": "Close",
      "refresh": "Refresh",
      "checking": "Checking every 3 seconds while a message waits.",
      "loadError": "The deliveries could not be loaded.",
      "rowsTitle": "Each attempt",
      "none": "No email or push was attempted.",
      "recipient": "Person",
      "channel": "Channel",
      "status": "Status",
      "reply": "Provider reply",
      "statuses": {
        "queued": "Queued",
        "sent": "Sent",
        "failed": "Failed"
      },
      "verdicts": {
        "accepted": "The provider accepted every message. If it did not arrive, look at the phone or the inbox, not the server.",
        "providerRefused": "The provider refused it. Check the credentials, the device token or the provider status. The queue worker is not involved.",
        "jobFailed": "The worker ran the job, and it failed. Read the error below.",
        "waiting": "Waiting for the queue worker to pick it up.",
        "workerStuck": "Still waiting after a minute. The queue worker is most likely not running.",
        "noDevice": "This person has no registered phone, so no push was sent. Sign in on the app to register one.",
        "noAddress": "This person has no email address, so no email was sent."
      }
    }
  },
  "feedback": {
    "report": {
      "action": "Report a problem",
      "title": "Report a problem or suggestion",
      "subtitle": "The support team reads every report.",
      "typeLabel": "What kind of report is this?",
      "type": {
        "problem": "Something is broken",
        "suggestion": "I have an idea"
      },
      "promptProblem": "Tell us what happened",
      "promptSuggestion": "What would make this better?",
      "descriptionPlaceholder": "The more you tell us, the faster we can fix it.",
      "charactersLeft": "{{count}} characters left",
      "disclosure": "We also send the page you are on, your language, and your browser version. We never send what you typed into other fields.",
      "screenshotLabel": "Add a picture (optional)",
      "screenshotHint": "Choose a file, drag it here, or paste it with Ctrl+V.",
      "chooseFile": "Choose a file",
      "fileSize": "{{size}} KB",
      "screenshotWrongType": "That file is not a picture. Please choose a JPG, PNG or WebP image.",
      "screenshotTooLarge": "That picture is too large. Please choose one under 5 MB.",
      "submit": "Send",
      "submitting": "Sending…",
      "errorTitle": "The report did not send",
      "errorBody": "Please check your connection and try again. Nothing you wrote has been lost.",
      "thanksTitle": "Thank you",
      "thanksBody": "Your report reached the support team. We will contact you if we need more detail.",
      "referenceHint": "Quote this number if you call or email us.",
      "minChars": "At least 10 characters required",
      "copyReference": "Copy reference",
      "copiedReference": "Copied to clipboard",
      "dropActive": "Drop image here to attach",
      "pasteHint": "or paste with Ctrl+V",
      "promptHintProblem": "Describe what you were trying to do, what happened instead, and any steps to reproduce.",
      "promptHintSuggestion": "Describe your suggestion and how it would improve your daily work."
    },
    "action": "Report a problem or suggestion",
    "type": {
      "problem": "Problem",
      "suggestion": "Suggestion"
    },
    "descriptionProblem": "Tell us what happened",
    "descriptionSuggestion": "What would make this better?",
    "descriptionPlaceholder": "Describe the issue or idea in your own words.",
    "screenshot": {
      "label": "Screenshot (optional)",
      "hint": "Select, drag, or paste an image.",
      "dropzone": "Drop an image here",
      "change": "Change image",
      "remove": "Remove image",
      "errorType": "Only JPEG, PNG and WebP images are accepted.",
      "errorSize": "The image must be 5 MB or smaller."
    },
    "disclosure": "Your current page and basic browser details are sent with the report.",
    "submit": "Submit",
    "submitting": "Submitting…",
    "success": {
      "title": "Thank you",
      "body": "Your report has been sent to the support team.",
      "reference": "Reference: {{reference}}",
      "close": "Close"
    },
    "error": {
      "title": "Could not submit your report",
      "body": "Something went wrong. Your description and screenshot are still here — try again.",
      "retry": "Try again"
    },
    "admin": {
      "title": "Feedback",
      "subtitle": "Reports submitted by company users.",
      "inbox": {
        "emptyTitle": "No reports yet",
        "emptyBody": "Reports submitted by company users will appear here."
      },
      "columns": {
        "reference": "Reference",
        "type": "Type",
        "description": "Description",
        "company": "Company",
        "reporter": "Reporter",
        "submittedAt": "Submitted",
        "status": "Status",
        "priority": "Priority"
      },
      "filters": {
        "status": "Status",
        "statusAll": "All statuses",
        "type": "Type",
        "typeAll": "All types",
        "company": "Company",
        "companyPlaceholder": "All companies"
      },
      "detail": {
        "title": "Report {{reference}}",
        "description": "Description",
        "screenshot": "Screenshot",
        "screenshotDownload": "Download screenshot",
        "reporter": "Reporter",
        "reporterEmail": "Email or phone",
        "company": "Company",
        "group": "Group",
        "route": "Page",
        "locale": "Locale",
        "userAgent": "Browser",
        "supportReference": "Support reference",
        "submittedAt": "Submitted",
        "triage": {
          "title": "Triage",
          "status": "Status",
          "priority": "Priority",
          "internalNotes": "Internal notes",
          "internalNotesPlaceholder": "Notes visible only to platform administrators.",
          "save": "Save changes",
          "saving": "Saving…",
          "saved": "Changes saved",
          "error": "Could not save triage changes."
        }
      },
      "status": {
        "new": "New",
        "reviewing": "Reviewing",
        "resolved": "Resolved",
        "closed": "Closed"
      },
      "priority": {
        "low": "Low",
        "normal": "Normal",
        "high": "High",
        "urgent": "Urgent"
      }
    },
    "status": {
      "new": "New",
      "reviewing": "Reviewing",
      "resolved": "Resolved",
      "closed": "Closed"
    },
    "priority": {
      "low": "Low",
      "normal": "Normal",
      "high": "High",
      "urgent": "Urgent"
    },
    "locale": {
      "locale": "Locale",
      "en": "English",
      "ar": "Arabic"
    },
    "inbox": {
      "title": "Feedback",
      "subtitle": "Problems and suggestions reported from the company app.",
      "allStatuses": "Any status",
      "allTypes": "Any type",
      "allCompanies": "Any company",
      "hasScreenshot": "Has a picture",
      "emptyTitle": "No feedback yet",
      "emptyBody": "Reports from the company app appear here.",
      "noMatchTitle": "No reports match these filters",
      "noMatchBody": "Try widening the filters.",
      "searchPlaceholder": "Filter by reference, description or reporter...",
      "stats": {
        "total": "Total reports",
        "new": "New / Untriaged",
        "problems": "Problems",
        "suggestions": "Suggestions"
      },
      "filters": {
        "status": "Status",
        "statusAll": "Any status",
        "type": "Type",
        "typeAll": "Any type",
        "company": "Company",
        "companyPlaceholder": "Any company"
      },
      "columns": {
        "reference": "Reference",
        "type": "Type",
        "description": "What they told us",
        "company": "Company",
        "reporter": "Reporter",
        "submitted": "Submitted",
        "submittedAt": "Submitted",
        "status": "Status",
        "priority": "Priority",
        "screenshot": "Picture",
        "actions": "View"
      }
    },
    "detail": {
      "title": "Report {{reference}}",
      "reportedAt": "Reported {{at}}",
      "overview": "Report Details",
      "description": "What they told us",
      "screenshot": "Screenshot",
      "screenshotDownload": "Download screenshot",
      "zoomScreenshot": "Click image to view full size",
      "noScreenshot": "No picture was attached.",
      "screenshotAlt": "Picture attached by the reporter",
      "screenshotFailedTitle": "The picture could not be loaded",
      "screenshotFailedBody": "The report itself is unaffected. Try reloading the page.",
      "diagnostics": "Diagnostics & Context",
      "context": "Context",
      "reporter": "Reporter",
      "reporterEmail": "Email",
      "company": "Company",
      "group": "Group",
      "route": "Page",
      "userAgent": "Browser",
      "supportReference": "Support reference",
      "submittedAt": "Submitted",
      "submitted": "Submitted",
      "screen": "Screen",
      "language": "Language",
      "browser": "Browser",
      "logReference": "Log reference",
      "resolvedAt": "Resolved",
      "internalNotes": "Internal notes",
      "internalNotesPlaceholder": "What you found, what you tried, what to do next.",
      "internalNotesPrivate": "Only the platform team can see these notes. They are never shown to the reporter.",
      "saveFailed": "The change was not saved.",
      "triage": {
        "title": "Triage",
        "status": "Status",
        "priority": "Priority",
        "internalNotes": "Internal notes",
        "internalNotesPlaceholder": "What you found, what you tried, what to do next.",
        "error": "Could not save triage changes.",
        "saved": "Changes saved",
        "saving": "Saving…",
        "save": "Save changes"
      }
    }
  },
  "map": {
    "zoomIn": "Zoom in",
    "zoomOut": "Zoom out",
    "toggleAttribution": "Show map attribution",
    "unavailable": "The map could not be loaded."
  },
  "tabularReport": {
    "loadingTitle": "Report",
    "from": "From",
    "to": "To",
    "asAt": "As at",
    "resetPeriod": "Reset",
    "export": {
      "csv": "Export CSV",
      "pdf": "Export PDF"
    },
    "exportFailed": "The report could not be exported.",
    "loadFailed": "The report could not be loaded",
    "loadFailedDescription": "Check your connection and try again.",
    "emptyTitle": "Nothing to report",
    "emptyDescription": "There is nothing in this period for the warehouses you can see."
  },
  "documentCurrency": {
    "label": "Currency",
    "rate": "1 {{currency}} = {{rate}} {{base}}, the rate in force today. The order keeps the rate of its own date.",
    "quote": "1 {{currency}} = {{rate}} {{base}}, the rate on {{date}}. The document keeps this rate.",
    "noRate": "There is no {{currency}} rate on or before this date. Add one under exchange rates first.",
    "supplierNoRate": "This supplier bills in {{currency}}, but the company has no {{currency}} exchange rate, so this order is in {{base}}. Add a {{currency}} rate under exchange rates to order in {{currency}}.",
    "rateField": {
      "label": "Exchange rate",
      "onFile": "The rate on file for {{date}} is {{rate}}. A rate you change here applies to this order only.",
      "thisOrder": "A rate you change here applies to this order only.",
      "useOnFile": "Use the rate on file",
      "invalid": "Type a rate above zero, with at most 10 decimals."
    }
  },
  "serialNumbers": {
    "label": "Serial numbers",
    "placeholder": "One serial number per line",
    "count": "{{entered}} of {{expected}} entered"
  },
  "dashboardFilters": {
    "label": "Dashboard filters",
    "period": "Period",
    "presets": {
      "this_month": "This month",
      "last_month": "Last month",
      "this_quarter": "This quarter",
      "this_year": "This year",
      "custom": "Custom range"
    },
    "from": "From",
    "to": "To",
    "warehouse": "Warehouse",
    "allWarehouses": "All warehouses",
    "problem": {
      "incomplete": "Choose both a start and an end date.",
      "out_of_range": "Choose a range of up to a year that ends today or earlier."
    }
  },
  "documentEditor": {
    "shortcuts": "Keyboard shortcuts",
    "totals": "Totals",
    "hintNewLine": "new line",
    "hintMoveLines": "move between lines",
    "afterDiscounts": "After line discounts of {{amount}}",
    "onBase": "on {{amount}}",
    "withholding": "Withholding",
    "amountDue": "Amount due",
    "lineActions": "Line {{line}} actions",
    "duplicate": "Duplicate",
    "moveLineUp": "Move up",
    "moveLineDown": "Move down",
    "sku": "SKU",
    "customLine": "Custom line",
    "catalogItem": "Catalog item",
    "lineTotal": "Line total"
  },
  "employeeBulkPicker": {
    "label": "Choose employees",
    "searchPlaceholder": "Search by name or employee number",
    "searchHint": "Enter at least 2 characters.",
    "branchFilter": "Branch",
    "departmentFilter": "Department",
    "allBranches": "All branches",
    "allDepartments": "All departments",
    "branchUnavailable": "Branch name unavailable",
    "departmentUnavailable": "Department name unavailable",
    "noBranches": "No branches available",
    "noDepartments": "No departments available",
    "filterOptionsError": "Could not load filter options.",
    "retryFilters": "Retry",
    "noEmployees": "No eligible employees match these filters.",
    "selectAllEligible": "Select all eligible employees ({{count}})",
    "selectAllMatching": "Select all matching ({{count}})",
    "tooManyMatches": "More than 100 employees match. Narrow the branch, department, or search to select all matching.",
    "pages": "Employee result pages",
    "previousPage": "Previous page",
    "nextPage": "Next page",
    "pageOf": "Page {{current}} of {{total}}",
    "selectAllShown": "Select all shown",
    "selected": "Selected employees ({{count}})",
    "removeSelectedEmployee": "Remove {{employee}} from selection",
    "removeSelection": "Remove",
    "selectionLimit": "You can select up to 100 employees at once.",
    "optionsError": "Could not search employees.",
    "retrySearch": "Retry search"
  },
  "timeZone": {
    "search": "Search time zones",
    "empty": "No time zone matches.",
    "hint": "The local time for attendance, shifts, reminders and the mobile app."
  }
}
